import { compareValues1n2ayl87ihzfk as compareValues } from '../../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
import {
  binarySearchyyczvdessj07 as binarySearch,
  get_lastIndex1yw0x4k50k51w as get_lastIndex,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  first58ocm7j58k3q as first,
  last1vo29oleiqj36 as last,
  toList3jhuyej2anx2q as toList,
  toHashSet1qrcsl3g8ugc8 as toHashSet,
  first28gmhyvs4kf06 as first_0,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { KiteUiCoroutineScopeHelpers25rj47zs39igb as KiteUiCoroutineScopeHelpers } from '../KiteUiCoroutineScopeHelpers.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { HashMap1a0ld5kgwhmhv as HashMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/HashMap.mjs';
import {
  _ReactiveState___get_raw__impl__92ipya3q1gard26whe6 as _ReactiveState___get_raw__impl__92ipya,
  InternalReactiveWrapper6qytbrc1rcqv as InternalReactiveWrapper,
  InternalReactiveThrownException1wn4fe03qbefg as InternalReactiveThrownException,
  InternalReactiveNotActive_instanceavp2nits8goa as InternalReactiveNotActive_instance,
  InternalReactiveNotReady_instancer79hznuwejmn as InternalReactiveNotReady_instance,
  _ReactiveState___init__impl__fvdp9b3rxdz1mjh763m as _ReactiveState___init__impl__fvdp9b,
  ReactiveState__toString_impl_65vhu13kawcnu6lmh9s as ReactiveState__toString_impl_65vhu1,
  ReactiveState__getOrNull_impl_1asnfp338k3yl4xmyxq as ReactiveState__getOrNull_impl_1asnfp,
} from '../../../../../../reactive/com/lightningkite/reactive/core/ReactiveState.mjs';
import {
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
  toString1pkumu07cwy4m as toString,
  createThis2j2avj17cvnv2 as createThis,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  get_native16zxqjg6lrtlz as get_native,
  Job$cancel$ref2r8rkxbnqcz6i as Job$cancel$ref,
} from '../NativeElement.commonHtml.mjs';
import {
  get_animationsEnabled25ujr8oia8gbs as get_animationsEnabled,
  set_animationsEnabled1ac1lbh50s602 as set_animationsEnabled,
} from '../Element.ext.js.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  coerceAtLeastklytehohcpeq as coerceAtLeast,
  coerceAtMostfyc3emgaderp as coerceAtMost,
  downTo39qhfeycepm1j as downTo,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import {
  delayp0o4nsccwai as delay,
  delay2kng7ucb3aj62 as delay_0,
} from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { roundToInt1ue8x8yshtznx as roundToInt } from '../../../../../../kotlin-kotlin-stdlib/kotlin/math/math.mjs';
import {
  Signal1973xs1vkmdcb as Signal,
  RawReactive253xb355brtjj as RawReactive,
} from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import {
  Companion_getInstance37y5uk6rnmz38 as Companion_getInstance,
  Size2b01934yxlz5f as Size,
  Companion_getInstance1vsa8jrdqad0h as Companion_getInstance_0,
} from '../../models/Rect.mjs';
import { throwUninitializedPropertyAccessException14fok093f3k3t as throwUninitializedPropertyAccessException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/internal/ThrowHelpers.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  get_centerX2in8u6xgwmvfr as get_centerX,
  get_centerY2o32deip08ur4 as get_centerY,
  RecyclerViewPlaceable30p36x6wixz5i as RecyclerViewPlaceable,
} from './RecyclerViewPlaceable.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import {
  Companion_instance1lm8x0jadqh2g as Companion_instance,
  Platform_Web_getInstance2840w5bkfolz8 as Platform_Web_getInstance,
} from '../../Platform.mjs';
import { get_current2r182tjucmm5v as get_current } from '../../Platform.js.mjs';
import {
  Align_Start_getInstance48vaevgl3nrq as Align_Start_getInstance,
  Align_End_getInstancer37lklmdzqms as Align_End_getInstance,
  Align_Center_getInstance366ihr7rj12mu as Align_Center_getInstance,
} from '../../models/data.mjs';
import {
  plus354lvypr4cqa1 as plus,
  ThemeDerivation3kcl449hwgd5y as ThemeDerivation,
} from '../../models/Theme.mjs';
import { applyAlpha3k2fcxahu1lgz as applyAlpha } from '../../models/Paint.mjs';
import {
  SpecificElement1fm8kkyg4nw48 as SpecificElement,
  FuzzyIndex1f984se19g5yx as FuzzyIndex,
} from './RecyclerViewAnchor.mjs';
import {
  Companion_getInstance2jahap30xtp3t as Companion_getInstance_1,
  toDuration7gy6v749ektt as toDuration,
  _Duration___get_inWholeMilliseconds__impl__msfiry33sjnw92ish9p as _Duration___get_inWholeMilliseconds__impl__msfiry,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_SECONDS_getInstance162tnxlnf2fpv as DurationUnit_SECONDS_getInstance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import {
  RecyclerViewDatag1ccuuuhm5zb as RecyclerViewData,
  Empty_instance2ua06mt98yjia as Empty_instance,
} from './RecyclerViewData.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  RecyclerViewRendererSet341fhovxcnndi as RecyclerViewRendererSet,
  Empty_instance2wsoq14uj8bky as Empty_instance_0,
} from './RecyclerViewRendererSet.mjs';
import { KtMutableList1beimitadwkna as KtMutableList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import {
  get_theme90wn9glxu60a as get_theme,
  set_padding5v7ifiir6y9y as set_padding,
} from '../Element.ext.mjs';
import { isNaNymqb93xtq8w8 as isNaN_0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/NumbersJs.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/compareTo.mjs';
import { withWritedlio9p0oewet as withWrite } from '../../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import { themed2vu67ornd4jps as themed } from '../themeDerivations.mjs';
import { ScrollingBehaviorImpl35p8dxbs74spr as ScrollingBehaviorImpl } from '../direct/ScrollView.commonHtml.js.mjs';
import { beforeSetup1a13mbd699ddp as beforeSetup } from '../ElementWriter.ext.mjs';
import { nativeSetupPullToRefresh2bvrvj8yisrqy as nativeSetupPullToRefresh } from '../direct/modifiers.commonHtml.js.mjs';
import { ProgrammaticLayout96iub9zkgjmh as ProgrammaticLayout } from '../direct/ProgrammaticLayout.js.mjs';
import {
  ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement,
  Companion_getInstanceztgx4sy4wjnt as Companion_getInstance_2,
} from '../NativeElement.mjs';
import {
  get_unpadded1ygmnwh0rw79t as get_unpadded,
  sizeConstraints19w9rda6g3rqz as sizeConstraints,
} from '../direct/modifiers.mjs';
import { Frame1e7t2kcdb3wu7 as Frame } from '../direct/Frame.commonHtml.mjs';
import {
  get_atBottom2b5zia3cn544c as get_atBottom,
  get_atEnd34105oxxaxc2o as get_atEnd,
} from '../helpers.mjs';
import { get_rem2p56fiaxda5jo as get_rem } from '../../models/data.commonHtml.mjs';
import { AppState_getInstance33x03n2an9aul as AppState_getInstance } from '../../reactive/AppState.js.mjs';
import { get_viewUnits3uus4yl4di64 as get_viewUnits } from '../../models/data.js.mjs';
import { RecyclerViewPlacerVerticalGrid1jojlivaz3vdj as RecyclerViewPlacerVerticalGrid } from './RecyclerViewPlacerVerticalGrid.mjs';
import { HashSet2dzve9y63nf0v as HashSet } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/HashSet.mjs';
import { reactive2xic0rufq5s8n as reactive } from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { onRemove3k528udkni1ni as onRemove } from '../../../../../../reactive/com/lightningkite/reactive/context/CalculationContext.mjs';
import {
  ElementWithChildren23tv2h1ul7ktb as ElementWithChildren,
  Element1y2xoj9fs2s4 as Element,
} from '../Element.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var Recycler2$MyCell$setup$writer$1Class;
function Recycler2$MyCell$setup$writer$1() {
  if (Recycler2$MyCell$setup$writer$1Class === VOID) {
    class $ {
      constructor(this$0, this$1, $index) {
        this.this$0__1 = this$0;
        this.this$1__1 = this$1;
        this.$index_1 = $index;
        this.$$delegate_0__1 = this$0.cells_1;
      }
      addChild_2qpft2_k$(element) {
        this.this$1__1.view_1 = element;
        if (this.this$0__1.recycling_1) {
          this.this$0__1.cells_1.addChild_2qpft2_k$(element);
        } else {
          var tmp;
          if (this.this$0__1.activeCells_1.isEmpty_y1axqb_k$()) {
            tmp = -1;
          } else if (this.$index_1 > last(this.this$0__1.activeCells_1).get_index_it478p_k$()) {
            tmp = -1;
          } else if (this.$index_1 < first(this.this$0__1.activeCells_1).get_index_it478p_k$()) {
            tmp = 1;
          } else {
            var tmp0 = this.this$0__1.activeCells_1;
            // Inline function 'kotlin.collections.binarySearchBy' call
            var key = this.$index_1;
            var toIndex = tmp0.get_size_woubt6_k$();
            // Inline function 'kotlin.let' call
            var it = binarySearch(tmp0, 0, toIndex, (it) => {
              var tmp$ret$1 = it.get_index_it478p_k$();
              return compareValues(tmp$ret$1, key);
            });
            tmp = (it < 0 ? (-it | 0) - 1 | 0 : it) + 1 | 0;
          }
          var index = tmp;
          if (index === -1) {
            this.this$0__1.cells_1.addChild_2qpft2_k$(element);
          } else {
            this.this$0__1.cells_1.addChild_51cm2s_k$(index, element);
          }
        }
      }
      get_context_h02k06_k$() {
        return this.$$delegate_0__1.get_context_h02k06_k$();
      }
      willAddChild_hz2iwc_k$(element) {
        this.$$delegate_0__1.willAddChild_hz2iwc_k$(element);
      }
      invoke_bnq13k_k$(_this__u8e3s4, actionToCalculate) {
        return this.$$delegate_0__1.invoke_bnq13k_k$(_this__u8e3s4, actionToCalculate);
      }
      get_coroutineContext_115oqo_k$() {
        return this.$$delegate_0__1.get_coroutineContext_115oqo_k$();
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [KiteUiCoroutineScopeHelpers()]);
    Recycler2$MyCell$setup$writer$1Class = $;
  }
  return Recycler2$MyCell$setup$writer$1Class;
}
function measure$runPlacer(this$0, this$1, activeCells, reuseableCells, data, rendererSet, $inProgress) {
  this$0.statsLayouts_1 = this$0.statsLayouts_1 + 1 | 0;
  this$0.usedCells_1.clear_j9egeb_k$();
  var overdraw = this$1.viewport_1.copy_afmpo5_k$(this$1.viewport_1.left_1 - this$0.overdraw_1, this$1.viewport_1.top_1 - this$0.overdraw_1, this$1.viewport_1.right_1 + this$0.overdraw_1, this$1.viewport_1.bottom_1 + this$0.overdraw_1);
  var previousCells = toList(activeCells);
  var instantDismissCount = 0;
  activeCells.clear_j9egeb_k$();
  var _iterator__ex2g4s = previousCells.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var cell = _iterator__ex2g4s.next_20eer_k$();
    if (!rectOverlaps(cell.left_1, cell.top_1, cell.right_1, cell.bottom_1, overdraw.left_1, overdraw.top_1, overdraw.right_1, overdraw.bottom_1)) {
      cell.get_view_wow8a6_k$().set_shown_mavbz5_k$(false);
      if (this$0.recycling_1) {
        reuseableCells.add_utx5q5_k$(cell);
      } else {
        this$0.cells_1.removeChild_kofmvd_k$(cell.get_view_wow8a6_k$());
      }
      instantDismissCount = instantDismissCount + 1 | 0;
    } else {
      activeCells.add_utx5q5_k$(cell);
    }
  }
  var tmp0_safe_receiver = this$0.log_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.log_iyb52q_k$(['OFFSCREEN CELLS DISMISSED: ' + instantDismissCount]);
  }
  if (data.get_range_ixu978_k$().isEmpty_y1axqb_k$())
    return Unit_instance;
  var activeCellsByID = HashMap().new_kotlin_collections_HashMap_5ewlp_k$(imul(activeCells.get_size_woubt6_k$(), 2));
  var _iterator__ex2g4s_0 = activeCells.iterator_jk1svi_k$();
  while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
    var cell_0 = _iterator__ex2g4s_0.next_20eer_k$();
    // Inline function 'com.lightningkite.reactive.core.ReactiveState.handle' call
    // Inline function 'com.lightningkite.reactive.core.ReactiveState.handle' call
    var this_0 = cell_0.data_1.get_state_wc71uu_k$();
    var tmp0_subject = _ReactiveState___get_raw__impl__92ipya(this_0);
    var tmp;
    if (equals(tmp0_subject, InternalReactiveNotReady_instance)) {
      tmp = Unit_instance;
    } else {
      if (equals(tmp0_subject, InternalReactiveNotActive_instance)) {
        tmp = Unit_instance;
      } else {
        if (tmp0_subject instanceof InternalReactiveThrownException()) {
          _ReactiveState___get_raw__impl__92ipya(this_0).exception_1;
          tmp = Unit_instance;
        } else {
          if (tmp0_subject instanceof InternalReactiveWrapper()) {
            var it = _ReactiveState___get_raw__impl__92ipya(this_0).other_1;
            // Inline function 'kotlin.collections.set' call
            var key = rendererSet.id_r7ceoc_k$(it);
            activeCellsByID.put_4fpzoq_k$(key, cell_0);
            tmp = Unit_instance;
          } else {
            var it_0 = _ReactiveState___get_raw__impl__92ipya(this_0);
            // Inline function 'kotlin.collections.set' call
            var key_0 = rendererSet.id_r7ceoc_k$(it_0);
            activeCellsByID.put_4fpzoq_k$(key_0, cell_0);
            tmp = Unit_instance;
          }
        }
      }
    }
  }
  var tmp1_safe_receiver = this$0.log_1;
  if (tmp1_safe_receiver == null)
    null;
  else {
    tmp1_safe_receiver.log_iyb52q_k$(['RUN PLACER IN ' + this$1.viewport_1.toString() + ', anchor is ' + toString_0(this$0.anchor_1)]);
  }
  var tmp2_$this = this$0.placer_1;
  var tmp3_dataRange = data.get_range_ixu978_k$();
  var tmp4_anchor = this$0.anchor_1;
  var tmp5_previousViewport = this$0.previousViewport_1;
  var tmp6_viewport = this$1.viewport_1;
  var tmp7_paddingTop = $inProgress.get_paddingTop_iol9mb_k$();
  var tmp8_paddingLeft = $inProgress.get_paddingLeft_axk5v5_k$();
  var tmp9_paddingRight = $inProgress.get_paddingRight_gckk44_k$();
  var tmp10_paddingBottom = $inProgress.get_paddingBottom_24qann_k$();
  var tmp11_gap = $inProgress.get_gap_18j5ar_k$();
  tmp2_$this.place_wvys22_k$(tmp3_dataRange, tmp4_anchor, tmp5_previousViewport, previousCells, (index, size) => {
    var tmp;
    var progression = data.get_range_ixu978_k$();
    var containsLower = progression.first_1;
    var containsUpper = progression.last_1;
    if (!(containsLower <= index ? index <= containsUpper : false)) {
      throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$("You can't pull a cell not in data range.");
    }
    var item = data.get_c1px32_k$(index);
    var renderer = rendererSet.renderer_udxqk_k$(item);
    var id = rendererSet.id_r7ceoc_k$(item);
    var tmp0_safe_receiver = activeCellsByID.remove_gppy8k_k$(id);
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.takeIf' call
      var tmp_1;
      if (equals(tmp0_safe_receiver.get_type_wovaf7_k$(), renderer)) {
        tmp_1 = tmp0_safe_receiver;
      } else {
        tmp_1 = null;
      }
      tmp_0 = tmp_1;
    }
    var tmp1_safe_receiver = tmp_0;
    var tmp_2;
    if (tmp1_safe_receiver == null) {
      tmp_2 = null;
    } else {
      // Inline function 'kotlin.also' call
      tmp1_safe_receiver.onPullForPlacing_q0dqf5_k$(size, _ReactiveState___init__impl__fvdp9b(item), index, $inProgress);
      tmp_2 = tmp1_safe_receiver;
    }
    var tmp2_elvis_lhs = tmp_2;
    var tmp_3;
    if (tmp2_elvis_lhs == null) {
      // Inline function 'kotlin.takeIf' call
      var this_0 = reuseableCells;
      var tmp_4;
      if (this$0.recycling_1) {
        tmp_4 = this_0;
      } else {
        tmp_4 = null;
      }
      var tmp3_safe_receiver = tmp_4;
      var tmp_5;
      if (tmp3_safe_receiver == null) {
        tmp_5 = null;
      } else {
        tmp_5 = popOrNull(tmp3_safe_receiver, (it) => equals(it.get_type_wovaf7_k$(), renderer));
      }
      var tmp4_safe_receiver = tmp_5;
      var tmp_6;
      if (tmp4_safe_receiver == null) {
        tmp_6 = null;
      } else {
        // Inline function 'kotlin.also' call
        // Inline function 'com.lightningkite.kiteui.views.withoutAnimation' call
        var this_1 = tmp4_safe_receiver.get_view_wow8a6_k$();
        var tmp_7 = get_native(this_1).element_1;
        var tmp0_safe_receiver_0 = tmp_7 instanceof HTMLElement ? tmp_7 : null;
        var tmp_8;
        if (tmp0_safe_receiver_0 == null) {
          tmp_8 = null;
        } else {
          // Inline function 'com.lightningkite.kiteui.views.withoutAnimation' call
          var this_2 = tmp0_safe_receiver_0;
          var animate = get_animationsEnabled();
          try {
            if (animate) {
              set_animationsEnabled(false);
              // Inline function 'com.lightningkite.kiteui.views.direct.suppressMutationObserverForClass' call
              // Inline function 'kotlin.js.asDynamic' call
              var tmp_9 = this_2.__suppressMutationObserverClass;
              var tmp0_elvis_lhs = tmp_9 instanceof ArrayList() ? tmp_9 : null;
              var tmp_10;
              if (tmp0_elvis_lhs == null) {
                // Inline function 'kotlin.run' call
                var n = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
                // Inline function 'kotlin.js.asDynamic' call
                this_2.__suppressMutationObserverClass = n;
                tmp_10 = n;
              } else {
                tmp_10 = tmp0_elvis_lhs;
              }
              var e = tmp_10;
              this_2.classList.add('notransition');
              var tmp1_elvis_lhs = this_2.getAttribute('class');
              e.add_utx5q5_k$(tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
            }
            tmp4_safe_receiver.onPullForPlacing_q0dqf5_k$(size, _ReactiveState___init__impl__fvdp9b(item), index, $inProgress);
          }finally {
            if (animate) {
              var tmp_11 = window;
              tmp_11.setTimeout(() => {
                // Inline function 'com.lightningkite.kiteui.views.direct.suppressMutationObserverForClass' call
                var this_0 = this_2;
                // Inline function 'kotlin.js.asDynamic' call
                var tmp = this_0.__suppressMutationObserverClass;
                var tmp0_elvis_lhs = tmp instanceof ArrayList() ? tmp : null;
                var tmp_0;
                if (tmp0_elvis_lhs == null) {
                  // Inline function 'kotlin.run' call
                  var n = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
                  // Inline function 'kotlin.js.asDynamic' call
                  this_0.__suppressMutationObserverClass = n;
                  tmp_0 = n;
                } else {
                  tmp_0 = tmp0_elvis_lhs;
                }
                var e = tmp_0;
                this_2.classList.remove('notransition');
                var tmp1_elvis_lhs = this_0.getAttribute('class');
                e.add_utx5q5_k$(tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
                return Unit_instance;
              }, 100);
              set_animationsEnabled(true);
            }
          }
          tmp_8 = Unit_instance;
        }
        if (tmp_8 == null) {
          tmp4_safe_receiver.onPullForPlacing_q0dqf5_k$(size, _ReactiveState___init__impl__fvdp9b(item), index, $inProgress);
        }
        // Inline function 'kotlin.collections.plusAssign' call
        activeCells.add_utx5q5_k$(tmp4_safe_receiver);
        tmp_6 = tmp4_safe_receiver;
      }
      tmp_3 = tmp_6;
    } else {
      tmp_3 = tmp2_elvis_lhs;
    }
    var tmp5_elvis_lhs = tmp_3;
    var tmp_12;
    if (tmp5_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_3 = new (MyCell())(this$0);
      // Inline function 'com.lightningkite.kiteui.views.withoutAnimation' call
      var this_4 = this$0.cells_1;
      var tmp_13 = get_native(this_4).element_1;
      var tmp0_safe_receiver_1 = tmp_13 instanceof HTMLElement ? tmp_13 : null;
      var tmp_14;
      if (tmp0_safe_receiver_1 == null) {
        tmp_14 = null;
      } else {
        // Inline function 'com.lightningkite.kiteui.views.withoutAnimation' call
        var this_5 = tmp0_safe_receiver_1;
        var animate_0 = get_animationsEnabled();
        try {
          if (animate_0) {
            set_animationsEnabled(false);
            // Inline function 'com.lightningkite.kiteui.views.direct.suppressMutationObserverForClass' call
            // Inline function 'kotlin.js.asDynamic' call
            var tmp_15 = this_5.__suppressMutationObserverClass;
            var tmp0_elvis_lhs_0 = tmp_15 instanceof ArrayList() ? tmp_15 : null;
            var tmp_16;
            if (tmp0_elvis_lhs_0 == null) {
              // Inline function 'kotlin.run' call
              var n_0 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
              // Inline function 'kotlin.js.asDynamic' call
              this_5.__suppressMutationObserverClass = n_0;
              tmp_16 = n_0;
            } else {
              tmp_16 = tmp0_elvis_lhs_0;
            }
            var e_0 = tmp_16;
            this_5.classList.add('notransition');
            var tmp1_elvis_lhs_0 = this_5.getAttribute('class');
            e_0.add_utx5q5_k$(tmp1_elvis_lhs_0 == null ? '' : tmp1_elvis_lhs_0);
          }
          this_3.setup_r09v4q_k$(rendererSet.renderer_udxqk_k$(item), size, _ReactiveState___init__impl__fvdp9b(item), index, $inProgress);
        }finally {
          if (animate_0) {
            var tmp_17 = window;
            tmp_17.setTimeout(() => {
              // Inline function 'com.lightningkite.kiteui.views.direct.suppressMutationObserverForClass' call
              var this_0 = this_5;
              // Inline function 'kotlin.js.asDynamic' call
              var tmp = this_0.__suppressMutationObserverClass;
              var tmp0_elvis_lhs = tmp instanceof ArrayList() ? tmp : null;
              var tmp_0;
              if (tmp0_elvis_lhs == null) {
                // Inline function 'kotlin.run' call
                var n = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
                // Inline function 'kotlin.js.asDynamic' call
                this_0.__suppressMutationObserverClass = n;
                tmp_0 = n;
              } else {
                tmp_0 = tmp0_elvis_lhs;
              }
              var e = tmp_0;
              this_5.classList.remove('notransition');
              var tmp1_elvis_lhs = this_0.getAttribute('class');
              e.add_utx5q5_k$(tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
              return Unit_instance;
            }, 100);
            set_animationsEnabled(true);
          }
        }
        tmp_14 = Unit_instance;
      }
      if (tmp_14 == null) {
        this_3.setup_r09v4q_k$(rendererSet.renderer_udxqk_k$(item), size, _ReactiveState___init__impl__fvdp9b(item), index, $inProgress);
      }
      // Inline function 'kotlin.collections.plusAssign' call
      activeCells.add_utx5q5_k$(this_3);
      tmp_12 = this_3;
    } else {
      tmp_12 = tmp5_elvis_lhs;
    }
    // Inline function 'kotlin.also' call
    var this_6 = tmp_12;
    // Inline function 'kotlin.collections.plusAssign' call
    this$0.usedCells_1.add_utx5q5_k$(this_6);
    return this_6;
  }, tmp6_viewport, overdraw, tmp7_paddingTop, tmp8_paddingLeft, tmp9_paddingRight, tmp10_paddingBottom, tmp11_gap);
  this$0.previousViewport_1 = this$1.viewport_1;
  this$0.anchor_1 = null;
}
function measure$requestOffset(this$0, this$1, activeCells, x, y) {
  this$0.needToLayoutFirst_1 = true;
  var tmp0_safe_receiver = this$1.log_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.log_iyb52q_k$(['OFFSET: ' + x + ' / ' + y]);
  }
  var vx = coerceAtLeast(x, -this$0.viewport_1.left_1);
  var vy = coerceAtLeast(y, -this$0.viewport_1.top_1);
  var tmp1_safe_receiver = this$1.log_1;
  if (tmp1_safe_receiver == null)
    null;
  else {
    tmp1_safe_receiver.log_iyb52q_k$(['OFFSET2: ' + vx + ' / ' + vy]);
  }
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = activeCells.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    element.offset_aqkh19_k$(x, y);
  }
  this$1.previousViewport_1 = this$1.previousViewport_1.copy_afmpo5_k$(this$1.previousViewport_1.left_1 + vx, this$1.previousViewport_1.top_1 + vy, this$1.previousViewport_1.right_1 + vx, this$1.previousViewport_1.bottom_1 + vy);
  this$0.viewport_1 = this$0.viewport_1.copy_afmpo5_k$(this$0.viewport_1.left_1 + vx, this$0.viewport_1.top_1 + vy, this$0.viewport_1.right_1 + vx, this$0.viewport_1.bottom_1 + vy);
  this$0.queuedScrollJump_1 = to(this$0.viewport_1.left_1, this$0.viewport_1.top_1);
  this$0.sentinelSize_1 = coerceAtMost(this$0.sentinelSize_1 + (this$1.vertical_1 ? vy : vx), this$1.reallyBig_1);
}
function Recycler2$programmaticLayoutDelegate$o$measure$slambda($milliseconds, $cell, this$0, $reuse) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    yield* delay($milliseconds, $completion);
    $cell.get_view_wow8a6_k$().set_shown_mavbz5_k$(false);
    if (this$0.recycling_1) {
      $reuse.add_utx5q5_k$($cell);
    } else {
      this$0.cells_1.removeChild_kofmvd_k$($cell.get_view_wow8a6_k$());
    }
    return Unit_instance;
  }), 1);
}
function layout$commitPosition(this$0, $inProgress, it) {
  if (!(roundToInt(it.left_1) === roundToInt(it.leftOld_1)) || !(roundToInt(it.top_1) === roundToInt(it.topOld_1)) || !(roundToInt(it.right_1) === roundToInt(it.rightOld_1)) || !(roundToInt(it.bottom_1) === roundToInt(it.bottomOld_1))) {
    var tmp0_safe_receiver = this$0.log_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.log_iyb52q_k$(['CHANGING POSITION FOR ' + it.get_index_it478p_k$() + ' from (' + it.leftOld_1 + ', ' + it.topOld_1 + ') to (' + it.left_1 + ', ' + it.top_1 + ')']);
    }
    this$0.statsCellMoves_1 = this$0.statsCellMoves_1 + 1 | 0;
    $inProgress.place_lp1sg6_k$(it.get_view_wow8a6_k$(), it.left_1, it.top_1, it.right_1, it.bottom_1);
    it.leftOld_1 = it.left_1;
    it.topOld_1 = it.top_1;
    it.rightOld_1 = it.right_1;
    it.bottomOld_1 = it.bottom_1;
  }
}
var MyCellClass;
function MyCell() {
  if (MyCellClass === VOID) {
    class $ {
      constructor($outer) {
        this.$this_1 = $outer;
        this.indexProp_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(-1);
        this.data_1 = RawReactive().new_com_lightningkite_reactive_core_RawReactive_4h91ij_k$();
        this.constraint_1 = Companion_getInstance().Zero_1;
        this.inProgress_1 = null;
        this._size_1 = null;
        this.left_1 = 0.0;
        this.top_1 = 0.0;
        this.right_1 = 0.0;
        this.bottom_1 = 0.0;
        this.leftOld_1 = 0.0;
        this.topOld_1 = 0.0;
        this.rightOld_1 = 0.0;
        this.bottomOld_1 = 0.0;
      }
      get_type_wovaf7_k$() {
        var tmp = this.type_1;
        if (!(tmp == null))
          return tmp;
        else {
          throwUninitializedPropertyAccessException('type');
        }
      }
      get_view_wow8a6_k$() {
        var tmp = this.view_1;
        if (!(tmp == null))
          return tmp;
        else {
          throwUninitializedPropertyAccessException('view');
        }
      }
      setup_r09v4q_k$(type, constrain, data, index, inProgress) {
        this.type_1 = type;
        this.data_1.set_state_wnfcx0_k$(data);
        this.indexProp_1.set_value_v1vabv_k$(index);
        var tmp0_safe_receiver = this.$this_1.log_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.log_iyb52q_k$(['CELL CREATED: from ' + ReactiveState__toString_impl_65vhu1(data) + ' at ' + index]);
        }
        var writer = new (Recycler2$MyCell$setup$writer$1())(this.$this_1, this, index);
        type.render_qs4yp2_k$(writer, this.data_1, this.indexProp_1);
        this.constraint_1 = constrain;
        this._size_1 = null;
        this.inProgress_1 = inProgress;
      }
      onPullForPlacing_q0dqf5_k$(constrain, data, index, inProgress) {
        this.get_view_wow8a6_k$().set_shown_mavbz5_k$(true);
        this.get_view_wow8a6_k$().set_opacity_ecw914_k$(1.0);
        this.data_1.set_state_wnfcx0_k$(data);
        this.indexProp_1.set_value_v1vabv_k$(index);
        this.constraint_1 = constrain;
        this._size_1 = null;
        this.inProgress_1 = inProgress;
      }
      get_index_it478p_k$() {
        return this.indexProp_1.get_value_j01efc_k$();
      }
      get_size_woubt6_k$() {
        var tmp0_elvis_lhs = this._size_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.run' call
          var _unary__edvuaz = this.$this_1.statsMeasures_1;
          this.$this_1.statsMeasures_1 = _unary__edvuaz + 1 | 0;
          var n = ensureNotNull(this.inProgress_1).measure_lv46sz_k$(this.get_view_wow8a6_k$(), this.constraint_1);
          this._size_1 = n;
          tmp = n;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
      get_left_woprgw_k$() {
        return this.left_1;
      }
      get_top_18ivbo_k$() {
        return this.top_1;
      }
      get_right_ixz7xv_k$() {
        return this.right_1;
      }
      get_bottom_bj8ras_k$() {
        return this.bottom_1;
      }
      place_2acamh_k$(left, top, right, bottom) {
        this.left_1 = left;
        this.top_1 = top;
        this.right_1 = right;
        this.bottom_1 = bottom;
      }
      offset_aqkh19_k$(x, y) {
        this.left_1 = this.left_1 + x;
        this.right_1 = this.right_1 + x;
        this.top_1 = this.top_1 + y;
        this.bottom_1 = this.bottom_1 + y;
      }
    }
    protoOf($).get_centerX_c9mbwa_k$ = get_centerX;
    protoOf($).get_centerY_c9mbwb_k$ = get_centerY;
    initMetadataForClass($, 'MyCell', VOID, VOID, [RecyclerViewPlaceable()]);
    MyCellClass = $;
  }
  return MyCellClass;
}
function _get_statsCellCount__kp2e3h($this) {
  return $this.cells_1.get_children_4cwbp4_k$().get_size_woubt6_k$();
}
function setFakeScrollByRatio($this, start, end) {
  var tmp0_safe_receiver = $this.log_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.log_iyb52q_k$(['setFakeScrollByRatio ' + start + ' - ' + end]);
  }
  if (get_current(Companion_instance).equals(Platform_Web_getInstance())) {
    var tmp1_elvis_lhs = ReactiveState__getOrNull_impl_1asnfp($this.get_fakeScroll_eyqyou_k$().get_viewport_c0gm8h_k$().get_state_wc71uu_k$());
    var tmp;
    if (tmp1_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var vp = tmp;
    var vps = $this.vertical_1 ? vp.get_height_e7t92o_k$() : vp.get_width_j0q4yl_k$();
    $this.fakeScrollSize_1 = vps / (end - start);
    $this.fakeScrollOffset_1 = start * $this.fakeScrollSize_1;
    var tmp2_safe_receiver = $this.log_1;
    if (tmp2_safe_receiver == null)
      null;
    else {
      tmp2_safe_receiver.log_iyb52q_k$(['fakeScrollSize: ' + $this.fakeScrollSize_1]);
    }
    var tmp3_safe_receiver = $this.log_1;
    if (tmp3_safe_receiver == null)
      null;
    else {
      tmp3_safe_receiver.log_iyb52q_k$(['vps: ' + vps]);
    }
    var tmp4_safe_receiver = $this.log_1;
    if (tmp4_safe_receiver == null)
      null;
    else {
      tmp4_safe_receiver.log_iyb52q_k$(['end: ' + end]);
    }
    var tmp5_safe_receiver = $this.log_1;
    if (tmp5_safe_receiver == null)
      null;
    else {
      tmp5_safe_receiver.log_iyb52q_k$(['start: ' + start]);
    }
    var tmp6_safe_receiver = $this.log_1;
    if (tmp6_safe_receiver == null)
      null;
    else {
      tmp6_safe_receiver.log_iyb52q_k$(['fakeScrollOffset: ' + $this.fakeScrollOffset_1]);
    }
    var tmp7_safe_receiver = $this.log_1;
    if (tmp7_safe_receiver == null)
      null;
    else {
      tmp7_safe_receiver.log_iyb52q_k$(['setFakeScrollByRatio calls invalidateLayout() on fake']);
    }
    $this.fakeScrollContent_1.invalidateLayout_x80ubv_k$();
  } else {
    var tmp8_elvis_lhs = ReactiveState__getOrNull_impl_1asnfp($this.get_fakeScroll_eyqyou_k$().get_viewport_c0gm8h_k$().get_state_wc71uu_k$());
    var tmp_0;
    if (tmp8_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_0 = tmp8_elvis_lhs;
    }
    var vp_0 = tmp_0;
    var vps_0 = $this.vertical_1 ? vp_0.get_height_e7t92o_k$() : vp_0.get_width_j0q4yl_k$();
    $this.fakeScrollSize_1 = vps_0 - 1.0;
    $this.fakeScrollIndicatorStart_1 = start;
    $this.fakeScrollIndicatorEnd_1 = end;
    if (end - start < 0.99) {
      if (!$this.indicatorShown_1) {
        $this.fakeScrollIndicator_1.set_opacity_ecw914_k$(1.0);
        $this.indicatorShown_1 = true;
      }
      var tmp9_safe_receiver = $this.hideIndicatorJob_1;
      if (tmp9_safe_receiver == null)
        null;
      else {
        tmp9_safe_receiver.cancel$default_8haxne_k$();
      }
      var tmp_1 = $this;
      tmp_1.hideIndicatorJob_1 = launch($this.fakeScrollIndicator_1, VOID, VOID, Recycler2$setFakeScrollByRatio$slambda($this));
    } else if ($this.indicatorShown_1) {
      $this.fakeScrollIndicator_1.set_opacity_ecw914_k$(0.0);
    }
    var tmp10_safe_receiver = $this.log_1;
    if (tmp10_safe_receiver == null)
      null;
    else {
      tmp10_safe_receiver.log_iyb52q_k$(['setFakeScrollByRatio calls invalidateLayout() on fake']);
    }
    $this.fakeScrollContent_1.invalidateLayout_x80ubv_k$();
  }
}
function Recycler2$firstIndex$slambda(this$0) {
  return constructCallableReference(($this$withWrite, it, $completion) => orPromise($completion, function *($completion) {
    var tmp;
    if (!(it === this$0._displayedRangeFirst_1.get_value_j01efc_k$())) {
      this$0.scrollToIndex$default_jrtwj0_k$(it, Align_Start_getInstance());
      tmp = Unit_instance;
    }
    return Unit_instance;
  }), 2);
}
function Recycler2$lastIndex$slambda(this$0) {
  return constructCallableReference(($this$withWrite, it, $completion) => orPromise($completion, function *($completion) {
    var tmp;
    if (!(it === this$0._displayedRangeLast_1.get_value_j01efc_k$())) {
      this$0.scrollToIndex$default_jrtwj0_k$(it, Align_End_getInstance());
      tmp = Unit_instance;
    }
    return Unit_instance;
  }), 2);
}
function Recycler2$centerIndex$slambda(this$0) {
  return constructCallableReference(($this$withWrite, it, $completion) => orPromise($completion, function *($completion) {
    var tmp;
    if (!(it === this$0._centerIndex_1.get_value_j01efc_k$())) {
      this$0.scrollToIndex$default_jrtwj0_k$(it, Align_Center_getInstance());
      tmp = Unit_instance;
    }
    return Unit_instance;
  }), 2);
}
var Recycler2$1Class;
function Recycler2$1() {
  if (Recycler2$1Class === VOID) {
    class $ {
      constructor($this_frame) {
        this.$this_frame_1 = $this_frame;
      }
      invoke_h6mny6_k$(theme) {
        return this.$this_frame_1.themeAndBack_1.drawBackground_1 ? theme.withBack_1 : theme.withoutBack_1;
      }
    }
    protoOf($).plus_duvq05_k$ = plus;
    initMetadataForClass($, VOID, VOID, VOID, [ThemeDerivation()]);
    Recycler2$1Class = $;
  }
  return Recycler2$1Class;
}
var Recycler2$2Class;
function Recycler2$2() {
  if (Recycler2$2Class === VOID) {
    class $ {
      invoke_h6mny6_k$(theme) {
        return theme.copy$default_vpegf4_k$('scrollindicator', VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, applyAlpha(theme.foreground_1, 0.5)).withBack_1;
      }
    }
    protoOf($).plus_duvq05_k$ = plus;
    initMetadataForClass($, VOID, VOID, VOID, [ThemeDerivation()]);
    Recycler2$2Class = $;
  }
  return Recycler2$2Class;
}
function Recycler2$scrollToIndex$slambda($milliseconds, $$this$run, $toIndex, $align, $animate) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    yield* delay($milliseconds, $completion);
    // Inline function 'kotlin.collections.find' call
    var tmp0 = $$this$run.activeCells_1;
    var tmp$ret$2;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
      while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
        var element = _iterator__ex2g4s.next_20eer_k$();
        if (element.get_index_it478p_k$() === $toIndex) {
          tmp$ret$2 = element;
          break $l$block;
        }
      }
      tmp$ret$2 = null;
    }
    var tmp0_safe_receiver = tmp$ret$2;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      var tmp_0 = $$this$run.get_scroll_7o7r1l_k$();
      var tmp_1;
      if ($$this$run.vertical_1) {
        tmp_1 = 0.0;
      } else {
        switch ($align.ordinal_1) {
          case 0:
            tmp_1 = tmp0_safe_receiver.left_1 - $$this$run.lastRecordedPaddingLeft_1;
            break;
          case 2:
            tmp_1 = tmp0_safe_receiver.right_1 - $$this$run.previousViewport_1.get_width_j0q4yl_k$();
            break;
          default:
            tmp_1 = tmp0_safe_receiver.get_centerX_c9mbwa_k$() - $$this$run.previousViewport_1.get_width_j0q4yl_k$() / 2;
            break;
        }
      }
      var tmp_2 = tmp_1;
      var tmp_3;
      if (!$$this$run.vertical_1) {
        tmp_3 = 0.0;
      } else {
        switch ($align.ordinal_1) {
          case 0:
            tmp_3 = tmp0_safe_receiver.top_1 - $$this$run.lastRecordedPaddingTop_1;
            break;
          case 2:
            tmp_3 = tmp0_safe_receiver.bottom_1 - $$this$run.previousViewport_1.get_height_e7t92o_k$();
            break;
          default:
            tmp_3 = tmp0_safe_receiver.get_centerY_c9mbwb_k$() - $$this$run.previousViewport_1.get_height_e7t92o_k$() / 2;
            break;
        }
      }
      tmp_0.scrollTo_gbpwk3_k$(tmp_2, tmp_3, $animate);
      tmp = Unit_instance;
    }
    if (tmp == null) {
      // Inline function 'kotlin.run' call
      var $this$run = $$this$run;
      $this$run.anchor_1 = new (SpecificElement())($toIndex, $align);
      $this$run.cells_1.invalidateLayout_x80ubv_k$();
    }
    return Unit_instance;
  }), 1);
}
function Recycler2$setFakeScrollByRatio$slambda(this$0) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'kotlin.time.Companion.seconds' call
    Companion_getInstance_1();
    var tmp$ret$0 = toDuration(1, DurationUnit_SECONDS_getInstance());
    yield* delay_0(tmp$ret$0, $completion);
    this$0.fakeScrollIndicator_1.set_opacity_ecw914_k$(0.0);
    this$0.indicatorShown_1 = false;
    return Unit_instance;
  }), 1);
}
var Recycler2$fakeScrollLayoutDelegate$1Class;
function Recycler2$fakeScrollLayoutDelegate$1() {
  if (Recycler2$fakeScrollLayoutDelegate$1Class === VOID) {
    class $ {
      constructor(this$0) {
        this.this$0__1 = this$0;
      }
      measure_gjrpfh_k$(layout, inProgress, within) {
        return this.this$0__1.vertical_1 ? new (Size())(within.width_1, this.this$0__1.fakeScrollSize_1) : new (Size())(this.this$0__1.fakeScrollSize_1, within.height_1);
      }
      layout_cdpgg7_k$(layout, inProgress, within) {
        if (get_current(Companion_instance).equals(Platform_Web_getInstance())) {
          var tmp0_safe_receiver = this.this$0__1.log_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            tmp0_safe_receiver.log_iyb52q_k$(['']);
          }
          this.this$0__1.suppressFakeScrollEvent_1 = true;
          var tmp0 = within.width_1;
          // Inline function 'kotlin.math.min' call
          var b = within.height_1;
          var s = Math.min(tmp0, b);
          if (this.this$0__1.vertical_1) {
            inProgress.place_lp1sg6_k$(this.this$0__1.fakeScrollIndicator_1, 0.0, this.this$0__1.fakeScrollSize_1 - 1, 1.0, this.this$0__1.fakeScrollSize_1);
          } else {
            inProgress.place_lp1sg6_k$(this.this$0__1.fakeScrollIndicator_1, this.this$0__1.fakeScrollSize_1 - 1, 0.0, this.this$0__1.fakeScrollSize_1, 1.0);
          }
          this.this$0__1.get_fakeScroll_eyqyou_k$().scrollTo_gbpwk3_k$(this.this$0__1.vertical_1 ? 0.0 : this.this$0__1.fakeScrollOffset_1, this.this$0__1.vertical_1 ? this.this$0__1.fakeScrollOffset_1 : 0.0, false);
        } else {
          if (this.this$0__1.vertical_1) {
            var size = coerceAtLeast((this.this$0__1.fakeScrollIndicatorEnd_1 - this.this$0__1.fakeScrollIndicatorStart_1) * within.height_1, within.width_1 * 2) / 2;
            var center = (this.this$0__1.fakeScrollIndicatorEnd_1 + this.this$0__1.fakeScrollIndicatorStart_1) / 2 * within.height_1;
            inProgress.place_lp1sg6_k$(this.this$0__1.fakeScrollIndicator_1, within.width_1 * 0.6, center - size, within.width_1 * 0.8, center + size);
          } else {
            var size_0 = coerceAtLeast((this.this$0__1.fakeScrollIndicatorEnd_1 - this.this$0__1.fakeScrollIndicatorStart_1) * within.width_1, within.height_1 * 2) / 2;
            var center_0 = (this.this$0__1.fakeScrollIndicatorEnd_1 + this.this$0__1.fakeScrollIndicatorStart_1) / 2 * within.width_1;
            var tmp1_child = this.this$0__1.fakeScrollIndicator_1;
            var tmp2_top = within.height_1 * 0.6;
            var tmp3_left = center_0 - size_0;
            var tmp4_bottom = within.height_1 * 0.8;
            var tmp5_right = center_0 + size_0;
            inProgress.place_lp1sg6_k$(tmp1_child, tmp3_left, tmp2_top, tmp5_right, tmp4_bottom);
          }
        }
      }
    }
    initMetadataForClass($);
    Recycler2$fakeScrollLayoutDelegate$1Class = $;
  }
  return Recycler2$fakeScrollLayoutDelegate$1Class;
}
function Recycler2$lambda() {
  return Unit_instance;
}
function Recycler2$lambda$slambda($milliseconds, this$0) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    yield* delay($milliseconds, $completion);
    this$0.isMoving_1.set_value_v1vabv_k$(false);
    this$0.cells_1.invalidateLayout_x80ubv_k$();
    return Unit_instance;
  }), 1);
}
var Recycler2$programmaticLayoutDelegate$1Class;
function Recycler2$programmaticLayoutDelegate$1() {
  if (Recycler2$programmaticLayoutDelegate$1Class === VOID) {
    class $ {
      constructor(this$0) {
        this.this$0__1 = this$0;
        this.queuedScrollJump_1 = null;
        this.viewport_1 = Companion_getInstance_0().Zero_1;
        this.lastMeasure_1 = null;
        this.sentinelSize_1 = this$0.reallyBig_1;
        this.stahp_1 = false;
        this.needToLayoutFirst_1 = false;
      }
      measure_gjrpfh_k$(layout, inProgress, within) {
        this.this$0__1.lastRecordedPaddingTop_1 = inProgress.get_paddingTop_iol9mb_k$();
        this.this$0__1.lastRecordedPaddingLeft_1 = inProgress.get_paddingLeft_axk5v5_k$();
        this.this$0__1.lastRecordedPaddingRight_1 = inProgress.get_paddingRight_gckk44_k$();
        this.this$0__1.lastRecordedPaddingBottom_1 = inProgress.get_paddingBottom_24qann_k$();
        if (this.stahp_1)
          return ensureNotNull(this.lastMeasure_1);
        var default_0 = within;
        if (within.equals(Companion_getInstance().Zero_1)) {
          var tmp0_safe_receiver = this.this$0__1.log_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            tmp0_safe_receiver.log_iyb52q_k$(['measure stop: if (within == Size.Zero) {']);
          }
          return default_0;
        }
        if (!this.needToLayoutFirst_1) {
          var tmp = this;
          var tmp1_elvis_lhs = ReactiveState__getOrNull_impl_1asnfp(this.this$0__1.get_scroll_7o7r1l_k$().get_viewport_c0gm8h_k$().get_state_wc71uu_k$());
          var tmp_0;
          if (tmp1_elvis_lhs == null) {
            // Inline function 'kotlin.run' call
            var tmp0_safe_receiver_0 = this.this$0__1.log_1;
            if (tmp0_safe_receiver_0 == null)
              null;
            else {
              tmp0_safe_receiver_0.log_iyb52q_k$(['measure stop: viewport = scroll.viewport.state.getOrNull() ?: run {']);
            }
            return default_0;
          } else {
            tmp_0 = tmp1_elvis_lhs;
          }
          tmp.viewport_1 = tmp_0;
        }
        var tmp2_safe_receiver = this.this$0__1.log_1;
        if (tmp2_safe_receiver == null)
          null;
        else {
          tmp2_safe_receiver.log_iyb52q_k$(['measure: Loaded viewport, found ' + this.viewport_1.toString()]);
        }
        if (this.viewport_1.get_width_j0q4yl_k$() === 0.0 || this.viewport_1.get_height_e7t92o_k$() === 0.0) {
          var tmp3_safe_receiver = this.this$0__1.log_1;
          if (tmp3_safe_receiver == null)
            null;
          else {
            tmp3_safe_receiver.log_iyb52q_k$(['measure stop: if (viewport.width == 0.0 || viewport.height == 0.0) {']);
          }
          return default_0;
        }
        var tmp4_safe_receiver = this.this$0__1.log_1;
        if (tmp4_safe_receiver == null)
          null;
        else {
          tmp4_safe_receiver.log_iyb52q_k$(['LAYOUT STARTING with size ' + within.toString()]);
        }
        var tmp_1 = this.this$0__1.data_1;
        var tmp5_elvis_lhs = (!(tmp_1 == null) ? isInterface(tmp_1, RecyclerViewData()) : false) ? tmp_1 : null;
        var tmp_2;
        if (tmp5_elvis_lhs == null) {
          // Inline function 'kotlin.run' call
          var tmp0_safe_receiver_1 = this.this$0__1.log_1;
          if (tmp0_safe_receiver_1 == null)
            null;
          else {
            tmp0_safe_receiver_1.log_iyb52q_k$(['measure stop: val data = data as? RecyclerViewData<Any, Any> ?: run {']);
          }
          return default_0;
        } else {
          tmp_2 = tmp5_elvis_lhs;
        }
        var data = tmp_2;
        var tmp_3 = this.this$0__1.rendererSet_1;
        var tmp6_elvis_lhs = (!(tmp_3 == null) ? isInterface(tmp_3, RecyclerViewRendererSet()) : false) ? tmp_3 : null;
        var tmp_4;
        if (tmp6_elvis_lhs == null) {
          // Inline function 'kotlin.run' call
          var tmp0_safe_receiver_2 = this.this$0__1.log_1;
          if (tmp0_safe_receiver_2 == null)
            null;
          else {
            tmp0_safe_receiver_2.log_iyb52q_k$(['measure stop: val rendererSet = rendererSet as? RecyclerViewRendererSet<Any, Any> ?: run {']);
          }
          return default_0;
        } else {
          tmp_4 = tmp6_elvis_lhs;
        }
        var rendererSet = tmp_4;
        var tmp_5 = this.this$0__1.activeCells_1;
        var tmp7_elvis_lhs = isInterface(tmp_5, KtMutableList()) ? tmp_5 : null;
        var tmp_6;
        if (tmp7_elvis_lhs == null) {
          // Inline function 'kotlin.run' call
          var tmp0_safe_receiver_3 = this.this$0__1.log_1;
          if (tmp0_safe_receiver_3 == null)
            null;
          else {
            tmp0_safe_receiver_3.log_iyb52q_k$(['measure stop: val activeCells = activeCells as? MutableList<MyCell<Any>> ?: run {']);
          }
          return default_0;
        } else {
          tmp_6 = tmp7_elvis_lhs;
        }
        var activeCells = tmp_6;
        var tmp_7 = this.this$0__1.reuseableCells_1;
        var tmp8_elvis_lhs = isInterface(tmp_7, KtMutableList()) ? tmp_7 : null;
        var tmp_8;
        if (tmp8_elvis_lhs == null) {
          // Inline function 'kotlin.run' call
          var tmp0_safe_receiver_4 = this.this$0__1.log_1;
          if (tmp0_safe_receiver_4 == null)
            null;
          else {
            tmp0_safe_receiver_4.log_iyb52q_k$(['measure stop: val reuseableCells = reuseableCells as? MutableList<MyCell<Any>> ?: run {']);
          }
          return default_0;
        } else {
          tmp_8 = tmp8_elvis_lhs;
        }
        var reuseableCells = tmp_8;
        var tmp9_safe_receiver = this.this$0__1.log_1;
        if (tmp9_safe_receiver == null)
          null;
        else {
          tmp9_safe_receiver.log_iyb52q_k$(['LAYOUT STARTED IN VIEWPORT ' + this.viewport_1.toString() + ', isMoving: ' + this.this$0__1.isMoving_1.get_value_j01efc_k$()]);
        }
        var tmp10_safe_receiver = this.this$0__1.log_1;
        if (tmp10_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          var reuseableSet = toHashSet(reuseableCells);
          var _iterator__ex2g4s = activeCells.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var cell = _iterator__ex2g4s.next_20eer_k$();
            if (reuseableSet.contains_aljjnj_k$(cell)) {
              tmp10_safe_receiver.log_iyb52q_k$(['WARNING!!! Active and reusable cell ' + toString(cell)]);
            }
          }
        }
        measure$runPlacer(this.this$0__1, this, activeCells, reuseableCells, data, rendererSet, inProgress);
        var firstCell = null;
        var lastCell = null;
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s_0 = this.this$0__1.usedCells_1.iterator_jk1svi_k$();
        while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s_0.next_20eer_k$();
          if (element.get_index_it478p_k$() === data.get_range_ixu978_k$().first_1)
            firstCell = element;
          if (element.get_index_it478p_k$() === data.get_range_ixu978_k$().last_1)
            lastCell = element;
        }
        var tmp11_safe_receiver = this.this$0__1.log_1;
        if (tmp11_safe_receiver == null)
          null;
        else {
          tmp11_safe_receiver.log_iyb52q_k$(['ATTACHMENT: ' + toString_0(firstCell) + ' / ' + toString_0(lastCell)]);
        }
        var tmp_9 = this;
        var tmp_10;
        if (!(lastCell == null)) {
          // Inline function 'kotlin.also' call
          var this_0 = this.this$0__1.vertical_1 ? lastCell.bottom_1 + inProgress.get_paddingBottom_24qann_k$() : lastCell.right_1 + inProgress.get_paddingRight_gckk44_k$();
          if (this.viewport_1.bottom_1 > this_0) {
            this.this$0__1.suppressScrollEvent_1 = true;
            this.this$0__1.suppressFakeScrollEvent_1 = true;
          }
          tmp_10 = this_0;
        } else {
          tmp_10 = this.this$0__1.reallyBig_1;
        }
        tmp_9.sentinelSize_1 = tmp_10;
        var tmp12_safe_receiver = this.this$0__1.log_1;
        if (tmp12_safe_receiver == null)
          null;
        else {
          tmp12_safe_receiver.log_iyb52q_k$(['SENTINEL SIZE: ' + this.sentinelSize_1]);
        }
        var atScrollEdge = (this.this$0__1.vertical_1 ? this.viewport_1.top_1 : this.viewport_1.left_1) < 1 || (this.this$0__1.vertical_1 ? this.viewport_1.bottom_1 : this.viewport_1.right_1) > this.this$0__1.reallyBig_1 - 1;
        if (!(firstCell == null)) {
          if (this.this$0__1.vertical_1) {
            // Inline function 'kotlin.math.abs' call
            var x = inProgress.get_paddingTop_iol9mb_k$() - firstCell.top_1;
            if (Math.abs(x) > 1.0) {
              var tmp13_safe_receiver = this.this$0__1.log_1;
              if (tmp13_safe_receiver == null)
                null;
              else {
                tmp13_safe_receiver.log_iyb52q_k$(['WILL OFFSET AT ' + this.viewport_1.toString()]);
              }
              if (this.viewport_1.top_1 < firstCell.top_1 - inProgress.get_paddingTop_iol9mb_k$() + 0.1) {
                var tmp14_safe_receiver = this.this$0__1.log_1;
                if (tmp14_safe_receiver == null)
                  null;
                else {
                  tmp14_safe_receiver.log_iyb52q_k$(['JERK REQUIRED: ' + this.viewport_1.top_1 + ' < ' + firstCell.top_1 + ' - ' + inProgress.get_paddingTop_iol9mb_k$()]);
                }
                measure$requestOffset(this, this.this$0__1, activeCells, 0.0, -firstCell.top_1 + inProgress.get_paddingTop_iol9mb_k$());
                this.this$0__1.anchor_1 = new (SpecificElement())(data.get_range_ixu978_k$().first_1, Align_Start_getInstance());
                var tmp15_safe_receiver = this.this$0__1.log_1;
                if (tmp15_safe_receiver == null)
                  null;
                else {
                  tmp15_safe_receiver.log_iyb52q_k$(['anchor = ' + toString_0(this.this$0__1.anchor_1) + ' (Offset follow up)']);
                }
                measure$runPlacer(this.this$0__1, this, activeCells, reuseableCells, data, rendererSet, inProgress);
              } else if (!this.this$0__1.isMoving_1.get_value_j01efc_k$()) {
                var tmp16_safe_receiver = this.this$0__1.log_1;
                if (tmp16_safe_receiver == null)
                  null;
                else {
                  tmp16_safe_receiver.log_iyb52q_k$(['SHIFTING CELLS TO ATTACH TO TOP: ' + firstCell.top_1 + ' -> ' + inProgress.get_paddingTop_iol9mb_k$()]);
                }
                measure$requestOffset(this, this.this$0__1, activeCells, 0.0, -firstCell.top_1 + inProgress.get_paddingTop_iol9mb_k$());
              }
            }
          } else {
            // Inline function 'kotlin.math.abs' call
            var x_0 = inProgress.get_paddingLeft_axk5v5_k$() - firstCell.left_1;
            if (Math.abs(x_0) > 1.0) {
              var tmp17_safe_receiver = this.this$0__1.log_1;
              if (tmp17_safe_receiver == null)
                null;
              else {
                tmp17_safe_receiver.log_iyb52q_k$(['WILL OFFSET AT ' + this.viewport_1.toString()]);
              }
              if (this.viewport_1.left_1 < firstCell.left_1 - inProgress.get_paddingLeft_axk5v5_k$() + 0.1) {
                var tmp18_safe_receiver = this.this$0__1.log_1;
                if (tmp18_safe_receiver == null)
                  null;
                else {
                  tmp18_safe_receiver.log_iyb52q_k$(['JERK REQUIRED: ' + this.viewport_1.left_1 + ' < ' + firstCell.left_1 + ' - ' + inProgress.get_paddingLeft_axk5v5_k$()]);
                }
                measure$requestOffset(this, this.this$0__1, activeCells, -firstCell.left_1 + inProgress.get_paddingLeft_axk5v5_k$(), 0.0);
                this.this$0__1.anchor_1 = new (SpecificElement())(data.get_range_ixu978_k$().first_1, Align_Start_getInstance());
                var tmp19_safe_receiver = this.this$0__1.log_1;
                if (tmp19_safe_receiver == null)
                  null;
                else {
                  tmp19_safe_receiver.log_iyb52q_k$(['anchor = ' + toString_0(this.this$0__1.anchor_1) + ' (Offset follow up)']);
                }
                measure$runPlacer(this.this$0__1, this, activeCells, reuseableCells, data, rendererSet, inProgress);
              } else if (!this.this$0__1.isMoving_1.get_value_j01efc_k$()) {
                var tmp20_safe_receiver = this.this$0__1.log_1;
                if (tmp20_safe_receiver == null)
                  null;
                else {
                  tmp20_safe_receiver.log_iyb52q_k$(['SHIFTING CELLS TO ATTACH TO TOP: ' + firstCell.left_1 + ' -> ' + inProgress.get_paddingLeft_axk5v5_k$()]);
                }
                measure$requestOffset(this, this.this$0__1, activeCells, -firstCell.left_1 + inProgress.get_paddingLeft_axk5v5_k$(), 0.0);
              }
            }
          }
        } else {
          var tmp_11;
          // Inline function 'kotlin.collections.isNotEmpty' call
          if (!this.this$0__1.usedCells_1.isEmpty_y1axqb_k$()) {
            tmp_11 = !this.this$0__1.isMoving_1.get_value_j01efc_k$() || atScrollEdge;
          } else {
            tmp_11 = false;
          }
          if (tmp_11) {
            var sampleCell = first_0(this.this$0__1.usedCells_1);
            var tmp_12;
            if (this.this$0__1.vertical_1) {
              var containsLower = this.this$0__1.reallyBig_1 * 1 / 4;
              var containsUpper = this.this$0__1.reallyBig_1 * 3 / 4;
              var containsArg = sampleCell.top_1;
              tmp_12 = !(containsLower <= containsArg ? containsArg <= containsUpper : false);
            } else {
              var containsLower_0 = this.this$0__1.reallyBig_1 * 1 / 4;
              var containsUpper_0 = this.this$0__1.reallyBig_1 * 3 / 4;
              var containsArg_0 = sampleCell.left_1;
              tmp_12 = !(containsLower_0 <= containsArg_0 ? containsArg_0 <= containsUpper_0 : false);
            }
            var needsRecentering = tmp_12;
            var tmp21_safe_receiver = this.this$0__1.log_1;
            if (tmp21_safe_receiver == null)
              null;
            else {
              tmp21_safe_receiver.log_iyb52q_k$(['' + sampleCell.left_1 + ' (at index ' + sampleCell.get_index_it478p_k$() + ') !in (' + this.this$0__1.reallyBig_1 * 1 / 4 + ')..(' + this.this$0__1.reallyBig_1 * 3 / 4 + ')']);
            }
            var tmp22_safe_receiver = this.this$0__1.log_1;
            if (tmp22_safe_receiver == null)
              null;
            else {
              tmp22_safe_receiver.log_iyb52q_k$(['needsRecentering: ' + needsRecentering + ', atFalseEdge: ' + atScrollEdge + ', isMoving: ' + this.this$0__1.isMoving_1.get_value_j01efc_k$()]);
            }
            if (needsRecentering) {
              if (this.this$0__1.vertical_1) {
                measure$requestOffset(this, this.this$0__1, activeCells, 0.0, this.this$0__1.reallyBig_1 * 0.5 - sampleCell.top_1);
              } else {
                measure$requestOffset(this, this.this$0__1, activeCells, this.this$0__1.reallyBig_1 * 0.5 - sampleCell.left_1, 0.0);
              }
            }
          }
        }
        var inductionVariable = get_lastIndex(activeCells);
        if (0 <= inductionVariable)
          $l$loop: do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + -1 | 0;
            var cell_0 = activeCells.get_c1px32_k$(i);
            if (this.this$0__1.usedCells_1.contains_aljjnj_k$(cell_0))
              continue $l$loop;
            var tmp23_safe_receiver = this.this$0__1.log_1;
            if (tmp23_safe_receiver == null)
              null;
            else {
              tmp23_safe_receiver.log_iyb52q_k$(['Dismissing cell at ' + cell_0.get_index_it478p_k$()]);
            }
            if (rectOverlaps(cell_0.left_1, cell_0.top_1, cell_0.right_1, cell_0.bottom_1, this.viewport_1.left_1, this.viewport_1.top_1, this.viewport_1.right_1, this.viewport_1.bottom_1)) {
              cell_0.get_view_wow8a6_k$().set_opacity_ecw914_k$(0.0);
              var reuse = reuseableCells;
              activeCells.removeAt_6niowx_k$(i);
              var tmp0 = this.this$0__1;
              // Inline function 'com.lightningkite.kiteui.afterTimeout' call
              var milliseconds = _Duration___get_inWholeMilliseconds__impl__msfiry(get_theme(cell_0.get_view_wow8a6_k$()).transitionDuration_1);
              var job = launch(tmp0, VOID, VOID, Recycler2$programmaticLayoutDelegate$o$measure$slambda(milliseconds, cell_0, this.this$0__1, reuse));
              Job$cancel$ref(job);
            } else {
              cell_0.get_view_wow8a6_k$().set_shown_mavbz5_k$(false);
              activeCells.removeAt_6niowx_k$(i);
              if (this.this$0__1.recycling_1) {
                reuseableCells.add_utx5q5_k$(cell_0);
              } else {
                this.this$0__1.cells_1.removeChild_kofmvd_k$(cell_0.get_view_wow8a6_k$());
              }
            }
          }
           while (0 <= inductionVariable);
        var v = this.this$0__1.vertical_1 ? within.copy$default_q06iir_k$(VOID, this.sentinelSize_1) : within.copy$default_q06iir_k$(this.sentinelSize_1);
        this.lastMeasure_1 = v;
        var tmp24_safe_receiver = this.this$0__1.log_1;
        if (tmp24_safe_receiver == null)
          null;
        else {
          tmp24_safe_receiver.log_iyb52q_k$(['Measure complete, result: ' + v.toString()]);
        }
        return v;
      }
      layout_cdpgg7_k$(layout, inProgress, within) {
        var tmp0_safe_receiver = this.this$0__1.log_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.log_iyb52q_k$(['LAYOUT PROPER STARTED: ' + within.toString()]);
        }
        if (this.stahp_1)
          return Unit_instance;
        if (!this.needToLayoutFirst_1) {
          this.measure_gjrpfh_k$(layout, inProgress, within);
        }
        if (this.this$0__1.vertical_1) {
          inProgress.place_lp1sg6_k$(this.this$0__1.scrollSentinel_1, 0.0, this.sentinelSize_1, within.width_1, this.sentinelSize_1 + 1);
        } else {
          inProgress.place_lp1sg6_k$(this.this$0__1.scrollSentinel_1, this.sentinelSize_1, 0.0, this.sentinelSize_1 + 1, within.height_1);
        }
        if (within.equals(Companion_getInstance().Zero_1))
          return Unit_instance;
        var tmp1_elvis_lhs = ReactiveState__getOrNull_impl_1asnfp(this.this$0__1.get_scroll_7o7r1l_k$().get_viewport_c0gm8h_k$().get_state_wc71uu_k$());
        var tmp;
        if (tmp1_elvis_lhs == null) {
          return Unit_instance;
        } else {
          tmp = tmp1_elvis_lhs;
        }
        var viewport = tmp;
        if (viewport.get_width_j0q4yl_k$() === 0.0 || viewport.get_height_e7t92o_k$() === 0.0)
          return Unit_instance;
        try {
          this.this$0__1.inLayout_1 = true;
          // Inline function 'kotlin.collections.forEach' call
          var _iterator__ex2g4s = this.this$0__1.activeCells_1.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var element = _iterator__ex2g4s.next_20eer_k$();
            layout$commitPosition(this.this$0__1, inProgress, element);
          }
        }finally {
          this.this$0__1.inLayout_1 = false;
        }
        var tmp2_safe_receiver = this.this$0__1.data_1;
        if (tmp2_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          $l$block_1: {
            if (this.this$0__1.fakeScrollInControl_1) {
              break $l$block_1;
            }
            if (this.this$0__1.activeCells_1.isEmpty_y1axqb_k$()) {
              break $l$block_1;
            }
            var totalWeight = 0.0;
            var weightedIndexSum = 0.0;
            var weightedPositionSum = 0.0;
            var _iterator__ex2g4s_0 = this.this$0__1.activeCells_1.iterator_jk1svi_k$();
            while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
              var cell = _iterator__ex2g4s_0.next_20eer_k$();
              var tmp0 = cell.right_1;
              // Inline function 'kotlin.math.min' call
              var b = viewport.right_1;
              var tmp_0 = Math.min(tmp0, b);
              var tmp0_0 = cell.left_1;
              // Inline function 'kotlin.math.max' call
              var b_0 = viewport.left_1;
              var h = (tmp_0 - Math.max(tmp0_0, b_0)) / (cell.right_1 - cell.left_1);
              var tmp0_1 = cell.bottom_1;
              // Inline function 'kotlin.math.min' call
              var b_1 = viewport.bottom_1;
              var tmp_1 = Math.min(tmp0_1, b_1);
              var tmp0_2 = cell.top_1;
              // Inline function 'kotlin.math.max' call
              var b_2 = viewport.top_1;
              var v = (tmp_1 - Math.max(tmp0_2, b_2)) / (cell.bottom_1 - cell.top_1);
              // Inline function 'kotlin.let' call
              var it = h * v;
              var ratio = isNaN_0(it) || it < 0.0 ? 0.0 : it;
              totalWeight = totalWeight + ratio;
              weightedIndexSum = weightedIndexSum + ratio * (cell.get_index_it478p_k$() + 0.5);
              weightedPositionSum = weightedPositionSum + ratio * (this.this$0__1.vertical_1 ? (cell.top_1 + cell.bottom_1) / 2 : (cell.left_1 + cell.right_1) / 2);
            }
            if (totalWeight === 0.0) {
              break $l$block_1;
            }
            var averageIndex = weightedIndexSum / totalWeight;
            var averagePosition = weightedPositionSum / totalWeight;
            var estimatedElementPx = (this.this$0__1.vertical_1 ? viewport.get_height_e7t92o_k$() : viewport.get_width_j0q4yl_k$()) / totalWeight;
            var totalElements = (tmp2_safe_receiver.get_range_ixu978_k$().last_1 - tmp2_safe_receiver.get_range_ixu978_k$().first_1 | 0) + 1 | 0;
            var estimatedTotalPx = estimatedElementPx * totalElements;
            var tmp0_safe_receiver_0 = this.this$0__1.log_1;
            if (tmp0_safe_receiver_0 == null)
              null;
            else {
              tmp0_safe_receiver_0.log_iyb52q_k$(['totalWeight: ' + totalWeight]);
            }
            var tmp1_safe_receiver = this.this$0__1.log_1;
            if (tmp1_safe_receiver == null)
              null;
            else {
              tmp1_safe_receiver.log_iyb52q_k$(['averageIndex: ' + averageIndex]);
            }
            var tmp2_safe_receiver_0 = this.this$0__1.log_1;
            if (tmp2_safe_receiver_0 == null)
              null;
            else {
              tmp2_safe_receiver_0.log_iyb52q_k$(['averagePosition: ' + averagePosition]);
            }
            var tmp3_safe_receiver = this.this$0__1.log_1;
            if (tmp3_safe_receiver == null)
              null;
            else {
              tmp3_safe_receiver.log_iyb52q_k$(['estimatedElementPx: ' + estimatedElementPx]);
            }
            var tmp4_safe_receiver = this.this$0__1.log_1;
            if (tmp4_safe_receiver == null)
              null;
            else {
              tmp4_safe_receiver.log_iyb52q_k$(['totalElements: ' + totalElements]);
            }
            var tmp5_safe_receiver = this.this$0__1.log_1;
            if (tmp5_safe_receiver == null)
              null;
            else {
              tmp5_safe_receiver.log_iyb52q_k$(['estimatedTotalPx: ' + estimatedTotalPx]);
            }
            var tmp6_safe_receiver = this.this$0__1.log_1;
            if (tmp6_safe_receiver == null)
              null;
            else {
              tmp6_safe_receiver.log_iyb52q_k$(['min: ' + (averageIndex - totalWeight / 2) / totalElements]);
            }
            var tmp7_safe_receiver = this.this$0__1.log_1;
            if (tmp7_safe_receiver == null)
              null;
            else {
              tmp7_safe_receiver.log_iyb52q_k$(['max: ' + (averageIndex + totalWeight / 2) / totalElements]);
            }
            setFakeScrollByRatio(this.this$0__1, (averageIndex - totalWeight / 2) / totalElements, (averageIndex + totalWeight / 2) / totalElements);
          }
        }
        var tmp3_safe_receiver_0 = this.queuedScrollJump_1;
        var tmp_2;
        if (tmp3_safe_receiver_0 == null) {
          tmp_2 = null;
        } else {
          // Inline function 'kotlin.let' call
          var tmp0_safe_receiver_1 = this.this$0__1.log_1;
          if (tmp0_safe_receiver_1 == null)
            null;
          else {
            tmp0_safe_receiver_1.log_iyb52q_k$(['EXECUTING SCROLL JUMP ' + toString_0(ReactiveState__getOrNull_impl_1asnfp(this.this$0__1.get_scroll_7o7r1l_k$().get_viewport_c0gm8h_k$().get_state_wc71uu_k$())) + ' = ' + tmp3_safe_receiver_0.toString()]);
          }
          this.this$0__1.suppressScrollEvent_1 = true;
          this.this$0__1.get_scroll_7o7r1l_k$().scrollToKeepAnimations_lpstn0_k$(tmp3_safe_receiver_0.first_1, tmp3_safe_receiver_0.second_1);
          this.queuedScrollJump_1 = null;
          tmp_2 = Unit_instance;
        }
        if (tmp_2 == null) {
          // Inline function 'kotlin.run' call
          var tmp0_3 = this.this$0__1.activeCells_1;
          var tmp$ret$14;
          $l$block_3: {
            // Inline function 'kotlin.collections.minByOrNull' call
            var iterator = tmp0_3.iterator_jk1svi_k$();
            if (!iterator.hasNext_bitz1p_k$()) {
              tmp$ret$14 = null;
              break $l$block_3;
            }
            var minElem = iterator.next_20eer_k$();
            if (!iterator.hasNext_bitz1p_k$()) {
              tmp$ret$14 = minElem;
              break $l$block_3;
            }
            var it_0 = minElem;
            var dx = it_0.get_centerX_c9mbwa_k$() - viewport.get_centerX_c9mbwa_k$();
            var dy = it_0.get_centerY_c9mbwb_k$() - viewport.get_centerY_c9mbwb_k$();
            var minValue = dx * dx + dy * dy;
            do {
              var e = iterator.next_20eer_k$();
              var dx_0 = e.get_centerX_c9mbwa_k$() - viewport.get_centerX_c9mbwa_k$();
              var dy_0 = e.get_centerY_c9mbwb_k$() - viewport.get_centerY_c9mbwb_k$();
              var v_0 = dx_0 * dx_0 + dy_0 * dy_0;
              if (compareTo(minValue, v_0) > 0) {
                minElem = e;
                minValue = v_0;
              }
            }
             while (iterator.hasNext_bitz1p_k$());
            tmp$ret$14 = minElem;
          }
          var tmp0_safe_receiver_2 = tmp$ret$14;
          var tmp1_elvis_lhs_0 = tmp0_safe_receiver_2 == null ? null : tmp0_safe_receiver_2.get_index_it478p_k$();
          this.this$0__1._centerIndex_1.set_value_v1vabv_k$(tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0);
        }
        if (this.this$0__1.activeCells_1.isEmpty_y1axqb_k$()) {
          this.this$0__1._displayedRangeFirst_1.set_value_v1vabv_k$(0);
          this.this$0__1._displayedRangeLast_1.set_value_v1vabv_k$(0);
        } else {
          var minIdx = 2147483647;
          var maxIdx = -2147483648;
          var _iterator__ex2g4s_1 = this.this$0__1.activeCells_1.iterator_jk1svi_k$();
          while (_iterator__ex2g4s_1.hasNext_bitz1p_k$()) {
            var cell_0 = _iterator__ex2g4s_1.next_20eer_k$();
            if (cell_0.get_index_it478p_k$() < minIdx)
              minIdx = cell_0.get_index_it478p_k$();
            if (cell_0.get_index_it478p_k$() > maxIdx)
              maxIdx = cell_0.get_index_it478p_k$();
          }
          this.this$0__1._displayedRangeFirst_1.set_value_v1vabv_k$(minIdx);
          this.this$0__1._displayedRangeLast_1.set_value_v1vabv_k$(maxIdx);
        }
        this.needToLayoutFirst_1 = false;
        var tmp5_safe_receiver_0 = this.this$0__1.log_1;
        if (tmp5_safe_receiver_0 == null)
          null;
        else {
          tmp5_safe_receiver_0.log_iyb52q_k$(['LAYOUT COMPLETE']);
        }
        var tmp6_safe_receiver_0 = this.this$0__1.log_1;
        if (tmp6_safe_receiver_0 == null)
          null;
        else {
          tmp6_safe_receiver_0.info_59mt0k_k$(['statsLayouts: ' + this.this$0__1.statsLayouts_1 + ', statsMeasures: ' + this.this$0__1.statsMeasures_1 + ', statsCellMoves: ' + this.this$0__1.statsCellMoves_1 + ', statsCellCount: ' + _get_statsCellCount__kp2e3h(this.this$0__1)]);
        }
      }
    }
    initMetadataForClass($);
    Recycler2$programmaticLayoutDelegate$1Class = $;
  }
  return Recycler2$programmaticLayoutDelegate$1Class;
}
var Recycler2Class;
function Recycler2() {
  if (Recycler2Class === VOID) {
    class $ {
      constructor(outerFrame, vertical, refreshAction, log) {
        return new.target.new_com_lightningkite_kiteui_views_l2_Recycler2_w7ucbj_k$(outerFrame, vertical, refreshAction, log);
      }
      static new_com_lightningkite_kiteui_views_l2_Recycler2_w7ucbj_k$(outerFrame, vertical, refreshAction, log) {
        var $this = createThis(this);
        $this.outerFrame_1 = outerFrame;
        $this.vertical_1 = vertical;
        $this.refreshAction_1 = refreshAction;
        $this.log_1 = log;
        $this.recycling_1 = true;
        $this._centerIndex_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(0);
        $this._displayedRangeFirst_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(0);
        var tmp = $this;
        tmp.firstIndex_1 = withWrite($this._displayedRangeFirst_1, Recycler2$firstIndex$slambda($this));
        $this._displayedRangeLast_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(0);
        var tmp_0 = $this;
        tmp_0.lastIndex_1 = withWrite($this._displayedRangeLast_1, Recycler2$lastIndex$slambda($this));
        var tmp_1 = $this;
        tmp_1.centerIndex_1 = withWrite($this._centerIndex_1, Recycler2$centerIndex$slambda($this));
        $this.snapToElements_1 = null;
        $this.scrollSnapStop_1 = false;
        // Inline function 'kotlin.with' call
        var $this$frame = $this.outerFrame_1;
        // Inline function 'com.lightningkite.kiteui.models.ThemeDerivation' call
        var tmp$ret$2 = new (Recycler2$1())($this$frame);
        // Inline function 'kotlin.let' call
        var writer = themed($this$frame, tmp$ret$2);
        var self_0 = $this;
        var ra = self_0.refreshAction_1;
        var tmp_2;
        if (!(ra == null)) {
          // Inline function 'com.lightningkite.kiteui.views.direct.scrollingWithRefresh' call
          // Inline function 'com.lightningkite.kiteui.views.direct.__scrollsWithRefreshUncontracted' call
          var vertical_0 = self_0.vertical_1;
          var horizontal = !self_0.vertical_1;
          var refreshAction_0 = ra;
          tmp_2 = beforeSetup(writer, ($this$beforeSetup) => {
            var $this$scrollingWithRefresh = new (ScrollingBehaviorImpl())($this$beforeSetup, horizontal, vertical_0);
            self_0.scroll_1 = $this$scrollingWithRefresh;
            $this$scrollingWithRefresh.set_showScrollBars_vutwwi_k$(false);
            var tmp;
            if (vertical_0) {
              get_native($this$beforeSetup).setStyleProperty_wavvb3_k$('overscroll-behavior-y', 'none');
              nativeSetupPullToRefresh($this$beforeSetup, refreshAction_0);
              tmp = Unit_instance;
            }
            return Unit_instance;
          });
        } else {
          // Inline function 'com.lightningkite.kiteui.views.direct.scrolling' call
          // Inline function 'com.lightningkite.kiteui.views.direct.__scrollsUncontracted' call
          var vertical_1 = self_0.vertical_1;
          var horizontal_0 = !self_0.vertical_1;
          tmp_2 = beforeSetup(writer, ($this$beforeSetup) => {
            var $this$scrolling = new (ScrollingBehaviorImpl())($this$beforeSetup, horizontal_0, vertical_1);
            self_0.scroll_1 = $this$scrolling;
            $this$scrolling.set_showScrollBars_vutwwi_k$(false);
            return Unit_instance;
          });
        }
        // Inline function 'com.lightningkite.kiteui.views.direct.programmatic' call
        var this_0 = tmp_2;
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element = new (ProgrammaticLayout())(this_0.get_context_h02k06_k$());
        ensureOutermostElement(element);
        this_0.willAddChild_hz2iwc_k$(element);
        set_padding(element, null);
        element.set_themeBase_daz04n_k$(Companion_getInstance_2().fromParentNonCascading_1);
        $this.cells_1 = element;
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        var this_1 = get_unpadded(element);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_0 = new (Frame())(this_1.get_context_h02k06_k$());
        ensureOutermostElement(element_0);
        this_1.willAddChild_hz2iwc_k$(element_0);
        $this.scrollSentinel_1 = element_0;
        element_0.onStartup_vrxh3i_k$();
        this_1.addChild_2qpft2_k$(element_0);
        element.onStartup_vrxh3i_k$();
        this_0.addChild_2qpft2_k$(element);
        var tmp_3;
        if ($this.vertical_1) {
          var tmp0_$receiver = get_atEnd($this$frame);
          var tmp1_width = get_rem(1);
          var tmp2_maxWidth = get_rem(1);
          tmp_3 = sizeConstraints(tmp0_$receiver, VOID, tmp2_maxWidth, VOID, VOID, VOID, tmp1_width);
        } else {
          var tmp3_$receiver = get_atBottom($this$frame);
          var tmp4_height = get_rem(1);
          var tmp5_maxHeight = get_rem(1);
          tmp_3 = sizeConstraints(tmp3_$receiver, VOID, VOID, VOID, tmp5_maxHeight, VOID, VOID, tmp4_height);
        }
        var tmp0 = tmp_3;
        // Inline function 'com.lightningkite.kiteui.views.direct.scrolling' call
        // Inline function 'com.lightningkite.kiteui.views.direct.__scrollsUncontracted' call
        var vertical_2 = $this.vertical_1;
        var horizontal_1 = !$this.vertical_1;
        // Inline function 'com.lightningkite.kiteui.views.direct.programmatic' call
        var this_2 = beforeSetup(tmp0, ($this$beforeSetup) => {
          var $this$scrolling = new (ScrollingBehaviorImpl())($this$beforeSetup, horizontal_1, vertical_2);
          $this.fakeScroll_1 = $this$scrolling;
          $this$scrolling.set_ignoreInteraction_ww4hrm_k$(!get_current(Companion_instance).equals(Platform_Web_getInstance()));
          return Unit_instance;
        });
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_1 = new (ProgrammaticLayout())(this_2.get_context_h02k06_k$());
        ensureOutermostElement(element_1);
        this_2.willAddChild_hz2iwc_k$(element_1);
        $this.fakeScrollContent_1 = element_1;
        element_1.set_ignoreInteraction_ww4hrm_k$(!get_current(Companion_instance).equals(Platform_Web_getInstance()));
        // Inline function 'com.lightningkite.kiteui.models.ThemeDerivation' call
        var tmp$ret$23 = new (Recycler2$2())();
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        var this_3 = get_unpadded(themed(element_1, tmp$ret$23));
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_2 = new (Frame())(this_3.get_context_h02k06_k$());
        ensureOutermostElement(element_2);
        this_3.willAddChild_hz2iwc_k$(element_2);
        element_2.set_ignoreInteraction_ww4hrm_k$(!get_current(Companion_instance).equals(Platform_Web_getInstance()));
        $this.fakeScrollIndicator_1 = element_2;
        element_2.set_opacity_ecw914_k$(0.0);
        element_2.onStartup_vrxh3i_k$();
        this_3.addChild_2qpft2_k$(element_2);
        element_1.onStartup_vrxh3i_k$();
        this_2.addChild_2qpft2_k$(element_1);
        $this.overdraw_1 = get_viewUnits(AppState_getInstance().get_windowInfo_amgsav_k$().get_value_j01efc_k$().height_1) / 3.0;
        $this.anchor_1 = new (SpecificElement())(0, Align_Start_getInstance());
        $this.placer_1 = new (RecyclerViewPlacerVerticalGrid())(1);
        $this.data_1 = Empty_instance;
        $this.rendererSet_1 = Empty_instance_0;
        $this.activeCells_1 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        $this.reuseableCells_1 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        $this.usedCells_1 = HashSet().new_kotlin_collections_HashSet_ovxcsm_k$();
        $this.reallyBig_1 = 50000.0;
        $this.inLayout_1 = false;
        $this.statsLayouts_1 = 0;
        $this.statsMeasures_1 = 0;
        $this.statsCellMoves_1 = 0;
        $this.hideIndicatorJob_1 = null;
        $this.indicatorShown_1 = false;
        $this.fakeScrollIndicatorStart_1 = 0.0;
        $this.fakeScrollIndicatorEnd_1 = 0.01;
        $this.fakeScrollInControl_1 = false;
        $this.suppressScrollEvent_1 = false;
        $this.suppressFakeScrollEvent_1 = false;
        $this.fakeScrollSize_1 = 0.0;
        $this.fakeScrollOffset_1 = 0.0;
        $this.lastRecordedPaddingTop_1 = 0.0;
        $this.lastRecordedPaddingLeft_1 = 0.0;
        $this.lastRecordedPaddingRight_1 = 0.0;
        $this.lastRecordedPaddingBottom_1 = 0.0;
        var tmp_4 = $this;
        tmp_4.fakeScrollLayoutDelegate_1 = new (Recycler2$fakeScrollLayoutDelegate$1())($this);
        $this.isMoving_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(false);
        $this.fakeScrollContent_1.set_delegate_q5h9as_k$($this.fakeScrollLayoutDelegate_1);
        if (get_current(Companion_instance).equals(Platform_Web_getInstance())) {
          var lastSize = {_v: Companion_getInstance().Zero_1};
          reactive($this.cells_1, VOID, ($this$reactive) => {
            var fsv = $this$reactive.invoke_r7m7el_k$($this.get_fakeScroll_eyqyou_k$().get_viewport_c0gm8h_k$());
            var tmp;
            if (!lastSize._v.equals(fsv.get_size_woubt6_k$())) {
              lastSize._v = fsv.get_size_woubt6_k$();
              return Unit_instance;
            }
            var tmp_0;
            if ($this.suppressFakeScrollEvent_1) {
              $this.suppressFakeScrollEvent_1 = false;
              return Unit_instance;
            }
            var tmp0_elvis_lhs = $this.data_1;
            var tmp_1;
            if (tmp0_elvis_lhs == null) {
              return Unit_instance;
            } else {
              tmp_1 = tmp0_elvis_lhs;
            }
            var data = tmp_1;
            var tmp_2;
            if ((data.get_range_ixu978_k$().last_1 - data.get_range_ixu978_k$().first_1 | 0) <= 0) {
              return Unit_instance;
            }
            var tmp_3;
            if ($this.fakeScrollSize_1 === 0.0) {
              return Unit_instance;
            }
            if ($this.vertical_1) {
              var topRatio = fsv.top_1 / $this.fakeScrollSize_1;
              var bottomRatio = fsv.bottom_1 / $this.fakeScrollSize_1;
              var centerRatio = (topRatio + bottomRatio) / 2;
              var controlRatio = topRatio + (bottomRatio - topRatio) * centerRatio;
              var controlIndex = controlRatio * ((data.get_range_ixu978_k$().last_1 - data.get_range_ixu978_k$().first_1 | 0) + 1 | 0);
              if ($this.snapToElements_1 == null)
                $this.anchor_1 = new (FuzzyIndex())(controlIndex, centerRatio);
              else
                $this.anchor_1 = new (SpecificElement())(roundToInt(controlIndex), ensureNotNull($this.snapToElements_1));
              var tmp1_safe_receiver = $this.log_1;
              if (tmp1_safe_receiver == null)
                null;
              else {
                tmp1_safe_receiver.log_iyb52q_k$(['anchor = ' + toString_0($this.anchor_1) + ' (web fake scroll)']);
              }
            } else {
              var topRatio_0 = fsv.left_1 / $this.fakeScrollSize_1;
              var bottomRatio_0 = fsv.right_1 / $this.fakeScrollSize_1;
              var centerRatio_0 = (topRatio_0 + bottomRatio_0) / 2;
              var controlRatio_0 = topRatio_0 + (bottomRatio_0 - topRatio_0) * centerRatio_0;
              var controlIndex_0 = controlRatio_0 * ((data.get_range_ixu978_k$().last_1 - data.get_range_ixu978_k$().first_1 | 0) + 1 | 0);
              if ($this.snapToElements_1 == null)
                $this.anchor_1 = new (FuzzyIndex())(controlIndex_0, centerRatio_0);
              else
                $this.anchor_1 = new (SpecificElement())(roundToInt(controlIndex_0), ensureNotNull($this.snapToElements_1));
              var tmp2_safe_receiver = $this.log_1;
              if (tmp2_safe_receiver == null)
                null;
              else {
                tmp2_safe_receiver.log_iyb52q_k$(['anchor = ' + toString_0($this.anchor_1) + ' (web fake scroll)']);
              }
            }
            $this.fakeScrollInControl_1 = true;
            var tmp3_safe_receiver = $this.log_1;
            if (tmp3_safe_receiver == null)
              null;
            else {
              tmp3_safe_receiver.log_iyb52q_k$(['fakeScrollInControl = true']);
            }
            var tmp4_safe_receiver = $this.log_1;
            if (tmp4_safe_receiver == null)
              null;
            else {
              tmp4_safe_receiver.log_iyb52q_k$(['fakeScroll.viewport calls invalidateLayout()']);
            }
            $this.cells_1.invalidateLayout_x80ubv_k$();
            return Unit_instance;
          });
        }
        var timeoutRemover = {_v: Recycler2$lambda};
        var tmp_5 = $this.get_scroll_7o7r1l_k$().get_viewport_c0gm8h_k$();
        onRemove($this.cells_1, tmp_5.addListener_6y9mct_k$(() => {
          $this.isMoving_1.set_value_v1vabv_k$(true);
          timeoutRemover._v();
          // Inline function 'com.lightningkite.kiteui.afterTimeout' call
          var this_0 = $this;
          var job = launch(this_0, VOID, VOID, Recycler2$lambda$slambda(100n, $this));
          var tmp$ret$27 = Job$cancel$ref(job);
          timeoutRemover._v = tmp$ret$27;
          if ($this.suppressScrollEvent_1) {
            $this.suppressScrollEvent_1 = false;
          } else {
            $this.fakeScrollInControl_1 = false;
            var tmp0_safe_receiver = $this.log_1;
            if (tmp0_safe_receiver == null)
              null;
            else {
              tmp0_safe_receiver.log_iyb52q_k$(['fakeScrollInControl = false']);
            }
          }
          var tmp;
          if (!$this.inLayout_1) {
            var tmp1_safe_receiver = $this.log_1;
            if (tmp1_safe_receiver == null)
              null;
            else {
              tmp1_safe_receiver.log_iyb52q_k$(['scroll.viewport calls invalidateLayout()']);
            }
            $this.cells_1.invalidateLayout_x80ubv_k$();
            tmp = Unit_instance;
          }
          return Unit_instance;
        }));
        $this.previousViewport_1 = Companion_getInstance_0().Zero_1;
        var tmp_6 = $this;
        tmp_6.programmaticLayoutDelegate_1 = new (Recycler2$programmaticLayoutDelegate$1())($this);
        $this.cells_1.set_delegate_q5h9as_k$($this.programmaticLayoutDelegate_1);
        return $this;
      }
      static new_com_lightningkite_kiteui_views_l2_Recycler2_cdij9p_k$(context, vertical, refreshAction, log) {
        vertical = vertical === VOID ? true : vertical;
        refreshAction = refreshAction === VOID ? null : refreshAction;
        log = log === VOID ? null : log;
        return this.new_com_lightningkite_kiteui_views_l2_Recycler2_w7ucbj_k$(new (Frame())(context), vertical, refreshAction, log);
      }
      get_scroll_7o7r1l_k$() {
        var tmp = this.scroll_1;
        if (!(tmp == null))
          return tmp;
        else {
          throwUninitializedPropertyAccessException('scroll');
        }
      }
      get_fakeScroll_eyqyou_k$() {
        var tmp = this.fakeScroll_1;
        if (!(tmp == null))
          return tmp;
        else {
          throwUninitializedPropertyAccessException('fakeScroll');
        }
      }
      get_children_4cwbp4_k$() {
        return this.cells_1.get_children_4cwbp4_k$();
      }
      set_paddingByEdge_53g79y_k$(value) {
        this.cells_1.set_paddingByEdge_53g79y_k$(value);
      }
      get_paddingByEdge_29dw58_k$() {
        return this.cells_1.paddingByEdge_1;
      }
      set_placer_s41hzn_k$(value) {
        this.placer_1 = value;
        var tmp0_safe_receiver = this.log_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.log_iyb52q_k$(['placer set calls invalidateLayout()']);
        }
        this.cells_1.invalidateLayout_x80ubv_k$();
      }
      set_data_kef13a_k$(value) {
        this.data_1 = value;
        var tmp0_safe_receiver = this.log_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.log_iyb52q_k$(['data set calls invalidateLayout()']);
        }
        this.cells_1.invalidateLayout_x80ubv_k$();
      }
      set_rendererSet_dok0gu_k$(value) {
        this.rendererSet_1 = value;
        // Inline function 'kotlin.collections.forEach' call
        var progression = downTo(get_lastIndex(this.cells_1.get_children_4cwbp4_k$()), 1);
        var inductionVariable = progression.first_1;
        var last = progression.last_1;
        var step = progression.step_1;
        if (step > 0 && inductionVariable <= last || (step < 0 && last <= inductionVariable))
          do {
            var element = inductionVariable;
            inductionVariable = inductionVariable + step | 0;
            var it = element;
            this.cells_1.removeChild_mjbjbk_k$(it);
          }
           while (!(element === last));
        this.activeCells_1 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        this.reuseableCells_1 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        var tmp0_safe_receiver = this.log_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.log_iyb52q_k$(['rendererSet set calls invalidateLayout()']);
        }
        this.cells_1.invalidateLayout_x80ubv_k$();
      }
      scrollToIndex_y3at9a_k$(toIndex, align, animate) {
        // Inline function 'kotlin.collections.find' call
        var tmp0 = this.activeCells_1;
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var element = _iterator__ex2g4s.next_20eer_k$();
            if (element.get_index_it478p_k$() === toIndex) {
              tmp$ret$1 = element;
              break $l$block;
            }
          }
          tmp$ret$1 = null;
        }
        var tmp0_safe_receiver = tmp$ret$1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          var tmp_0 = this.get_scroll_7o7r1l_k$();
          var tmp_1;
          if (this.vertical_1) {
            tmp_1 = 0.0;
          } else {
            switch (align.ordinal_1) {
              case 0:
                tmp_1 = tmp0_safe_receiver.left_1 - this.lastRecordedPaddingLeft_1;
                break;
              case 2:
                tmp_1 = tmp0_safe_receiver.right_1 - this.previousViewport_1.get_width_j0q4yl_k$();
                break;
              default:
                tmp_1 = tmp0_safe_receiver.get_centerX_c9mbwa_k$() - this.previousViewport_1.get_width_j0q4yl_k$() / 2;
                break;
            }
          }
          var tmp_2 = tmp_1;
          var tmp_3;
          if (!this.vertical_1) {
            tmp_3 = 0.0;
          } else {
            switch (align.ordinal_1) {
              case 0:
                tmp_3 = tmp0_safe_receiver.top_1 - this.lastRecordedPaddingTop_1;
                break;
              case 2:
                tmp_3 = tmp0_safe_receiver.bottom_1 - this.previousViewport_1.get_height_e7t92o_k$();
                break;
              default:
                tmp_3 = tmp0_safe_receiver.get_centerY_c9mbwb_k$() - this.previousViewport_1.get_height_e7t92o_k$() / 2;
                break;
            }
          }
          tmp_0.scrollTo_gbpwk3_k$(tmp_2, tmp_3, animate);
          tmp = Unit_instance;
        }
        if (tmp == null) {
          // Inline function 'kotlin.run' call
          var tmp_4;
          var tmp_5;
          if (animate) {
            // Inline function 'kotlin.collections.isNotEmpty' call
            tmp_5 = !this.activeCells_1.isEmpty_y1axqb_k$();
          } else {
            tmp_5 = false;
          }
          if (tmp_5) {
            // Inline function 'kotlin.collections.maxOf' call
            var iterator = this.activeCells_1.iterator_jk1svi_k$();
            if (!iterator.hasNext_bitz1p_k$())
              throw NoSuchElementException().new_kotlin_NoSuchElementException_wy3d4q_k$();
            var maxValue = iterator.next_20eer_k$().get_index_it478p_k$();
            while (iterator.hasNext_bitz1p_k$()) {
              var v = iterator.next_20eer_k$().get_index_it478p_k$();
              if (compareTo(maxValue, v) < 0) {
                maxValue = v;
              }
            }
            var destinationAhead = toIndex > maxValue;
            if (destinationAhead) {
              this.anchor_1 = new (SpecificElement())(toIndex, Align_End_getInstance());
            } else {
              this.anchor_1 = new (SpecificElement())(toIndex, Align_Start_getInstance());
            }
            this.cells_1.invalidateLayout_x80ubv_k$();
            // Inline function 'com.lightningkite.kiteui.afterTimeout' call
            var job = launch(this, VOID, VOID, Recycler2$scrollToIndex$slambda(16n, this, toIndex, align, animate));
            tmp_4 = Job$cancel$ref(job);
          } else {
            this.anchor_1 = new (SpecificElement())(toIndex, align);
            this.cells_1.invalidateLayout_x80ubv_k$();
            tmp_4 = Unit_instance;
          }
        }
      }
      scrollToIndex$default_jrtwj0_k$(toIndex, align, animate, $super) {
        animate = animate === VOID ? true : animate;
        var tmp;
        if ($super === VOID) {
          this.scrollToIndex_y3at9a_k$(toIndex, align, animate);
          tmp = Unit_instance;
        } else {
          tmp = $super.scrollToIndex_y3at9a_k$.call(this, toIndex, align, animate);
        }
        return tmp;
      }
      get_context_h02k06_k$() {
        return this.outerFrame_1.get_context_h02k06_k$();
      }
      get_underlyingNativeElement_vngz33_k$() {
        return this.outerFrame_1.get_underlyingNativeElement_vngz33_k$();
      }
      get_parent_hy4reb_k$() {
        return this.outerFrame_1.get_parent_hy4reb_k$();
      }
      onStartup_vrxh3i_k$() {
        this.outerFrame_1.onStartup_vrxh3i_k$();
      }
      onShutdown_5jzxq3_k$() {
        this.outerFrame_1.onShutdown_5jzxq3_k$();
      }
      set_opacity_ecw914_k$(_set____db54di) {
        this.outerFrame_1.set_opacity_ecw914_k$(_set____db54di);
      }
      set_shown_mavbz5_k$(_set____db54di) {
        this.outerFrame_1.set_shown_mavbz5_k$(_set____db54di);
      }
      get_shown_iyiju0_k$() {
        return this.outerFrame_1.get_shown_iyiju0_k$();
      }
      get_visible_8zfvk9_k$() {
        return this.outerFrame_1.get_visible_8zfvk9_k$();
      }
      set_safeAreaPadding_bpzgd4_k$(_set____db54di) {
        this.outerFrame_1.set_safeAreaPadding_bpzgd4_k$(_set____db54di);
      }
      set_themeChoice_py59um_k$(_set____db54di) {
        this.outerFrame_1.set_themeChoice_py59um_k$(_set____db54di);
      }
      get_themeChoice_22tyn3_k$() {
        return this.outerFrame_1.get_themeChoice_22tyn3_k$();
      }
      get_themeAndBack_k3yag2_k$() {
        return this.outerFrame_1.themeAndBack_1;
      }
      get_dragData_pas5on_k$() {
        return this.outerFrame_1.get_dragData_pas5on_k$();
      }
      get_dropTargetDelegate_fbdv1u_k$() {
        return this.outerFrame_1.get_dropTargetDelegate_fbdv1u_k$();
      }
      scrollIntoView_zcj1gb_k$(horizontal, vertical, animate) {
        this.outerFrame_1.scrollIntoView_zcj1gb_k$(horizontal, vertical, animate);
      }
      set_debugName_wihv62_k$(_set____db54di) {
        this.outerFrame_1.set_debugName_wihv62_k$(_set____db54di);
      }
      get_debugName_58dolx_k$() {
        return this.outerFrame_1.get_debugName_58dolx_k$();
      }
      set_describedBy_4bf3cf_k$(_set____db54di) {
        this.outerFrame_1.set_describedBy_4bf3cf_k$(_set____db54di);
      }
      get_driverValue_yh5neo_k$() {
        return this.outerFrame_1.get_driverValue_yh5neo_k$();
      }
      get_driverActions_8jqr2k_k$() {
        return this.outerFrame_1.get_driverActions_8jqr2k_k$();
      }
      driverDisplay_abwxi1_k$(options) {
        return this.outerFrame_1.driverDisplay_abwxi1_k$(options);
      }
      toString() {
        return this.outerFrame_1.toString();
      }
      invoke_bnq13k_k$(_this__u8e3s4, actionToCalculate) {
        return this.outerFrame_1.invoke_bnq13k_k$(_this__u8e3s4, actionToCalculate);
      }
      get_coroutineContext_115oqo_k$() {
        return this.outerFrame_1.get_coroutineContext_115oqo_k$();
      }
    }
    initMetadataForClass($, 'Recycler2', VOID, VOID, [ElementWithChildren(), Element()]);
    Recycler2Class = $;
  }
  return Recycler2Class;
}
function rectOverlaps(l1, t1, r1, b1, l2, t2, r2, b2) {
  return l1 < r2 && r1 > l2 && t1 < b2 && b1 > t2;
}
function popOrNull(_this__u8e3s4, condition) {
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.collections.indexOfFirst' call
    var index = 0;
    var _iterator__ex2g4s = _this__u8e3s4.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var item = _iterator__ex2g4s.next_20eer_k$();
      if (condition(item)) {
        tmp$ret$0 = index;
        break $l$block;
      }
      index = index + 1 | 0;
    }
    tmp$ret$0 = -1;
  }
  // Inline function 'kotlin.let' call
  var it = tmp$ret$0;
  return !(it === -1) ? _this__u8e3s4.removeAt_6niowx_k$(it) : null;
}
function estimateJumpAnchor(activeCells, vertical, viewport) {
  if (activeCells.isEmpty_y1axqb_k$())
    return null;
  var totalWeight = activeCells.get_size_woubt6_k$();
  // Inline function 'kotlin.collections.sumOf' call
  var sum = 0;
  var _iterator__ex2g4s = activeCells.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp = sum;
    sum = tmp + element.get_index_it478p_k$() | 0;
  }
  var averageIndex = sum / totalWeight | 0;
  var tmp_0;
  if (vertical) {
    // Inline function 'kotlin.collections.sumOf' call
    var sum_0 = 0;
    var _iterator__ex2g4s_0 = activeCells.iterator_jk1svi_k$();
    while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
      var element_0 = _iterator__ex2g4s_0.next_20eer_k$();
      var tmp_1 = sum_0;
      sum_0 = tmp_1 + (element_0.get_top_18ivbo_k$() + element_0.get_bottom_bj8ras_k$()) / 2;
    }
    tmp_0 = sum_0 / totalWeight;
  } else {
    // Inline function 'kotlin.collections.sumOf' call
    var sum_1 = 0;
    var _iterator__ex2g4s_1 = activeCells.iterator_jk1svi_k$();
    while (_iterator__ex2g4s_1.hasNext_bitz1p_k$()) {
      var element_1 = _iterator__ex2g4s_1.next_20eer_k$();
      var tmp_2 = sum_1;
      sum_1 = tmp_2 + (element_1.get_left_woprgw_k$() + element_1.get_right_ixz7xv_k$()) / 2;
    }
    tmp_0 = sum_1;
  }
  var averagePosition = tmp_0;
  // Inline function 'kotlin.collections.minOf' call
  var iterator = activeCells.iterator_jk1svi_k$();
  if (!iterator.hasNext_bitz1p_k$())
    throw NoSuchElementException().new_kotlin_NoSuchElementException_wy3d4q_k$();
  var it = iterator.next_20eer_k$();
  var minValue = vertical ? it.get_top_18ivbo_k$() : it.get_left_woprgw_k$();
  while (iterator.hasNext_bitz1p_k$()) {
    var it_0 = iterator.next_20eer_k$();
    var v = vertical ? it_0.get_top_18ivbo_k$() : it_0.get_left_woprgw_k$();
    // Inline function 'kotlin.comparisons.minOf' call
    var a = minValue;
    minValue = Math.min(a, v);
  }
  var min = minValue;
  // Inline function 'kotlin.collections.maxOf' call
  var iterator_0 = activeCells.iterator_jk1svi_k$();
  if (!iterator_0.hasNext_bitz1p_k$())
    throw NoSuchElementException().new_kotlin_NoSuchElementException_wy3d4q_k$();
  var it_1 = iterator_0.next_20eer_k$();
  var maxValue = vertical ? it_1.get_bottom_bj8ras_k$() : it_1.get_right_ixz7xv_k$();
  while (iterator_0.hasNext_bitz1p_k$()) {
    var it_2 = iterator_0.next_20eer_k$();
    var v_0 = vertical ? it_2.get_bottom_bj8ras_k$() : it_2.get_right_ixz7xv_k$();
    // Inline function 'kotlin.comparisons.maxOf' call
    var a_0 = maxValue;
    maxValue = Math.max(a_0, v_0);
  }
  var max = maxValue;
  var estimatedElementPx = (max - min) / totalWeight;
  var diff = (vertical ? viewport.get_centerY_c9mbwb_k$() : viewport.get_centerX_c9mbwa_k$()) - averagePosition;
  return new (FuzzyIndex())(averageIndex + diff / estimatedElementPx, 0.5);
}
//region block: exports
export {
  Recycler2 as Recycler21f097l2zl8cft,
  estimateJumpAnchor as estimateJumpAnchor3fhl00o07marf,
};
//endregion

//# sourceMappingURL=Recycler2.mjs.map
